import React from "react";
import "./GameViews/gameViews.css";
import "./GameViews/gameViewMedia.css";
import "../special/Special/special.css";
import { connect } from 'react-redux';
import { setInfo, incrementCount } from '../../redux/actionList';
import { Tooltip } from "@mui/material";

//  Datasets
import ConfigFile from "../../datasets/config_file";
import EventCategoryList from "./datasets/event_category_list";
import Config from '../../config';

//  Components
import CashMoodStatusBox from "./cash_mood_status_box";
import FriendDialogDisplay from "./friend_dialog_display";
import DisplayPurchasesModal from "./display_purchases_modal";
import GameBoardImageDisplay from "./game_board_image_display";
import GameCardFaceDown from "./game_card_face_down";
import GameCardFaceUp from "./game_card_face_up";
import GameSpinner from "./game_spinner";
import IconDisplayCard from "./icon_display_card";
import NotificationModal from "./notification_modal";
import SpinnerLegend from "./spinner_legend";
import TimelineHorizontal from "./timelineHorizontal";
import WaitTimeSpinner from "../shared-components/wait_time_spinner";
import AwardModal from "./award_modal";
import EarnBadge from "./earn_badge";
import CelebrationModal from "../shared-components/celebration_modal";
import ChangeGameSettingsModal from "./change_game_settings_modal";
import UnlockedFeaturesRoadmap from "./unlocked_features_roadmap";
//import CrackInWall from "./crack_in_wall";

// functions
import { buildUrl } from '../../objects/CommonUse/build_URL';
import { calcMonthlyIncome } from "../../objects/CommonUse/calcMonthlyIncome";
import { calcNbrFriendsMet } from "./objects/calc_nbr_friends_met";
import { calculateMoodRetirementScores } from "./objects/calculate_mood_retirement_scores";
import { calculateResponseAmount } from './objects/calculate_response_amount';
import { calcTaxAmt } from '../../objects/AssetsExpenses/taxAmtCalc_function';
import { checkIconTableEntries } from "./objects/check_iconTable_entries";
import { createNotificationsFromIconTable } from "./objectsEndOfTurn/create_notifications_from_icontable";
import { dateStrToPlainText } from "./objects/game_view_mask_functions";
import { determineIfTimeToMeetNewFriend } from "./objects/determine_if_time_to_meet_new_friend";    
import { findRemoveTableItem } from "../../objects/AssetsExpenses/find_remove_table_item";
import { getCurrentDateTime } from "../../objects/CommonUse/get_current_date_time";
import { lifestyleCard } from "./objectsForCard/lifestyle_card";
import { monthlyLoanAmt } from "../../objects/AssetsExpenses/loanAmtCalc_function";
import { processEventChangesToConditionsTable } from "./objects/process_event_changes_to_conditions_table";
import { setHeadersForFetch } from "../../objects/CommonUse/set_headers_for_fetch";
import { shuffleArray } from '../../objects/CommonUse/shuffleArray';
import { updateRecurringGameDataObjects } from "./objects/update_recurring_gamedata_objects";

// objects
import addCelebrationToNotificationArr from "./objectsEndOfTurn/add_celebration_to_notification_arr";
import applyCashOrCredit from "./objectsForCard/apply_cash_or_credit";
import buildBadgeCard from "./objectsForCard/build_badge_card";
import buildCardFromDialog from "./objectsForCard/build_card_from_dialog";
import buildJokeCard from "./objectsForCard/build_joke_card";
import calcRandomNumberWithMax from "../../objects/CommonUse/calc_random_number_with_max";
import calculateMoodPoints from "./objects/calculate_mood_points";
import checkForAchievements from "../../objects/CommonUse/check_for_achievements";
import closeOutThisTurn from "./objectsEndOfTurn/close_out_this_turn";
import createEventTrackerUpdateObject from "../../objects/CommonUse/create_eventTracker_update_object";
import createUnlockedFeatureRoadmapArr from "./objectsEndOfTurn/create_unlocked_feature_roadmap_arr";
import determineNextBadge from "./objects/determine_next_badge"
import determineImageURL from "./objects/determine_image_URL";
import determineWhichFriendToDisplay from "./objects/determine_which_friend_to_display";
import lastCardDataset from "./datasets/last_card_dataset";
import processNextTurn from "./objectsEndOfTurn/process_next_turn";
import replaceTextInString from "../../objects/CommonUse/replace_text_in_string";
import replaceInvalidCardEvents from "./objectsForCard/replace_invalid_card_events";
import retrieveGameDialog from "./objects/retrieve_game_dialog";
import updateGamePurchaseArr from "./objects/update_game_purchase_arr";
import updateEventArr from "./objects/update_event_arr";
import determineNotificationType from "../../objects/CommonUse/determine_notification_type";
import determineBackgroundURL from "./objects/determine_background_URL";



// mapStateToProps: pick the Redux state your component needs
const mapStateToProps = (state) => ({
    gameInfo: state,
    eligibleForCouponsDividends: state.eligibleForCouponsDividends,
    gameInvestments: state.gameInvestments,
    investmentMaster: state.investmentMaster,
    moneyMgmtTestArr: state.moneyMgmtTestArr,
     notificationArr: state.notificationArr,
    prevProcess: state.prevProcess,
    summaryInvestment: state.summaryInvestment,
    creditReport: state.creditReport,
    timeWizardInfo: state.timeWizardInfo,
    gameSettings: state.gameSettings,
    funStuffInfo: state.funStuffInfo,
   
    // add other Redux state slices here if needed
});

// mapDispatchToProps: make Redux actions available as props
const mapDispatchToProps = {
    setInfoRedux: setInfo,
    incrementTurnCount: incrementCount,
};


class GameBoard extends React.Component {
    gameInfo = null;
    _isMounted = false;
    constructor(props) {
        super(props);
        props.onOpen();
        this.gameInfo = this.props.gameInfo;
        this.trainVideoDone = this.trainVideoDone.bind(this);
        this.state = {
            siteURL: ConfigFile.general.siteURL,
            nextTurn: false,
            lastCard: false,
            openWarningModal: false,
            openNotificationModal: false,
            cardDisabled: false,
            eventTracker: ConfigFile.general.eventTracker,
            loggingMax: ConfigFile.general.loggingMax,
            headers: setHeadersForFetch(),
            dateTime: getCurrentDateTime(),
            dialogImgURL: "",
            friendDisplayType: "",
            friendImgUrl: "",
            count: 0,
            eventCategories: EventCategoryList,
            displayLegend: true,
            nextEventNbr: '',
            jokeCardBeginMonth: +this.props.totalNbrGameMonths - 5,
            gameDataLoaded: false,
            relatedDataLoaded: false,
            friendIndxList: [],
            funStuffObj: {},
            totalGameMonths: this.props.totalNbrGameMonths,
            timeout: 0,
            timeout2: 0,
            timeout3: 0,
            timeout4: 0,
            timeout5: 0,
            clickImageStartSw: false,
            validCardTypes: ["card", "badge", "joke"],
            subProcess: "GameBoard",
            environment: Config.dataURL.currentEnv,
            displayPurchases: false,
            notificationItem: {},
            awardModal: false,
            newAchievements: false,
            celebrationModal: false,
            earnBadge: false,
            maxNbrBadges: ConfigFile.gameBoard.maxBadges,
            pendingEndGame: false,
            responseReceived: false,
            flipCard: false,
            gameSettings: false,
            trainAnimation: true,
            holidayObj: ""
        }
        this.purchasesThisTurnArr = [];
        this.eventCategory = "";
        this.cardsReady = false;
        this.chargeItemToCreditCard = false;
        this.nbrFriendsMet = 0;

    }
        
    // Lifecycle events
    render() {
        this.purchasesExist = false;
        if (this.gameInfo.gamePurchases.purchaseTable && 
            this.gameInfo.gamePurchases.purchaseTable.length > 0){
                this.purchasesExist = true;
        }

        this.icons = this.gameInfo.gameData.iconTable.map((iconInfo, key) =>
            <IconDisplayCard key={key} iconList={iconInfo}
                onClick={(iconName) => this.openNotificationModal(iconName)} />
            );
        

        //  the first couple of times this is executed before GameChoicePictures but it works eventually
        this.backgroundURL = './assets/homes/bg_photo.jpg';
        if (this.gameInfo.pictureInfo.livingRoomImg ) {
            if (!this.gameInfo.backgroundURL ||
                this.gameInfo.backgroundURL === "" ) {
                this.backgroundURL = this.gameInfo.pictureInfo.livingRoomImg;
            } else {
                this.backgroundURL = this.gameInfo.backgroundURL;
            }
        }
         
        if (this.gameInfo.currentCard.backgroundType &&
            this.gameInfo.currentCard.backgroundType !== "home" &&
            this.backgroundURL === this.gameInfo.pictureInfo.livingRoomImg){
                //  trying to resolve an intermittent issue where the background
                //  displayed is not consistent with the current card
                if (this.gameInfo.gameData.user === "student8"){
                    alert ("background URL is NOT correct==> background URL is: " +
                        this.backgroundURL + " background  type: " +
                        this.gameInfo.currentCard.backgroundType
                    )
                }
                const errorDesc = "background URL is NOT correct";
                const errorObj = {backgroundURL: this.backgroundURL,
                    gameInfoBackgroundURL: this.gameInfo.backgroundURL,
                    pictureInfo: this.gameInfo.pictureInfo, 
                    cardBackgroundType: this.gameInfo.currentCard.backgroundType,
                    currentCard: this.gameInfo.currentCard }; 
                this.generalErrorLog(errorDesc, errorObj);
        }
              
        let cardList = [];
        if (this.gameInfo.cardList.length > 0 &&
            this._isMounted === true){
            if (this.gameInfo.gamePhase === "1") {
                cardList = this.gameInfo.cardList.map((key, index, card) =>
                    <GameCardFaceDown key={index} cardDetails={card} index={index}
                        nbrCards={this.gameInfo.cardList.length}
                        flipCard={this.state.flipCard}
                        cardDisabled={this.state.cardDisabled}
                        screenSize={this.props.screenSize}
                        onClick={() => this.processNextCard()} 
                        stopFlipCard={() => this.stopFlipCard()}
                        lastCard={(positionObj) => this.savePointerPosition(positionObj)}
                    />
                );
            }
            this.cardsReady = true;
        }
   
        if (!this.gameInfo.pictureInfo.livingRoomImg ||
            this.state.nextTurn === true ||  this.cardsReady === false){
                this.waitTimer = true;
        }else{
                this.waitTimer = false;
        }

        let unlockedFeatureRoadmap = [];
        if (this.unlockedFeaturesRoadmapArr && this.unlockedFeaturesRoadmapArr.length > 0){
            unlockedFeatureRoadmap = this.unlockedFeaturesRoadmapArr.map((feature, index) =>
                <UnlockedFeaturesRoadmap key={feature.nbr} featureInfo={feature} index={index}
                    totalNbrGameMonths={this.props.totalNbrGameMonths}
                />
            );
        }
        
        const tooltipPurchasesText = "Click to review game purchases.";
        const tooltipGameSettingsText = "Click to change the settings for your game."
        return <>
           <div className="col-sm-8 gameboard-height-max mt-3">
                <div className='card mr-3 rounded-corners-lg text-center game-board mt-5'
                    style={{ backgroundImage: `url(${process.env.PUBLIC_URL + this.backgroundURL})` }}>
                    {this.waitTimer  ?
                        <div className="game-board-rectangle">
                        <h3 className="mt-2 text-center ml-5 game-board-title-background">Game Board</h3>
                            {this.state.nextTurn  && this.state.trainAnimation ?
                                <div className="trainPosition">
                                    <img src="./assets/Events/TrainMovingBackground.jpg"
                                        className="train-end-of-turn" alt="trainStationTrack" />
                                    <div className="decorative begin-month-text text-white 
                                        font-weight-bold">{this.prevMonth}</div>
                                    <div className="decorative end-month-text text-white 
                                        font-weight-bold">{this.gameInfo.prevNextMonth.currentMonth}</div>
                                    <img src="./assets/Events/MoneyTrainReverse.png"
                                        onAnimationEnd={this.trainVideoDone}
                                        className="money-train-info move-train-on-track" alt="moneyTrain" />
                                    </div>
                            :        
                                    <WaitTimeSpinner />
                            }
                        </div>
                    :
                        <span>

                            <h3 className="mt-2 text-center ml-5 game-board-title-background">Game Board</h3>

                            <TimelineHorizontal
                                totalNbrGameMonths={this.props.totalNbrGameMonths}
                                gameNbrMonths={this.gameInfo.gameData.gameNbrMonths}
                                monthsPerTurn={this.monthsPerTurn}
                                screenSize={this.props.screenSize}
                                                    />
                            <img className="game-view-icons" src="./assets/Icons/largeRectangle.jpg" 
                                    alt="iconSpace"
                                />
                            <div className="text-center icon-text">
                                Click Picture to Learn More
                            </div>
                            <div className="ml-3">
                                 {this.icons}
                            </div>
                            <div>
                                <img className={this.awardButtonClass} 
                                    src="./assets/Awards/badge_button.png"
                                    onClick={() => this.openAwardModal()}
                                    onAnimationEnd={() => this.awardAnimationEnd()}
                                    alt="awardBtn"/>
                            </div>
                    
                            <div className="game-view-info py-2 px-3 font-weight-bold">
                                <CashMoodStatusBox
                                    gameDate={this.gameInfo.gameData.currentGameDate}
                                    currentCash={this.gameInfo.gameData.currentCash}
                                    currentMoodPoints={this.gameInfo.gameData.currentMoodPoints}
                                    moodEmoji={this.props.moodEmoji}
                               />
                              
                            </div>
                            {this.purchasesExist ?
                                <div>
                                    <Tooltip title={tooltipPurchasesText} arrow >
                                        <img className="purchases-picture"
                                            src="./assets/treasureChest.png" alt="treasureChest"
                                            onClick ={()=> this.displayPurchases("open")}
                                        />
                                    </Tooltip>
                                </div>
                            :
                                null
                            }

                            {+this.nbrMonthsPlayed >= 3 ?
                                 <Tooltip title={tooltipGameSettingsText} arrow >
                                    <button className="game-settings-button ml-4 mt-4" 
                                        onClick ={()=> this.changeGameSettings("open")}>
                                                Game Settings
                                    </button>
                                </Tooltip>
                            :
                                null
                            }

                            {this.gameInfo.gamePhase === "1" ?
                                <span>
                                    {cardList}
                                </span>
                            :
                                null
                            }

                            {this.state.clickImageStartSw && this.gameInfo.gamePhase === "1" ?
                                <div style={{position: "absolute", right: this.right, bottom: this.bottom}}>
                                    <img src="./assets/Icons/clickImg.jpg" 
                                        className="click-image-icon"
                                        alt="clickImageIcon" />
                                </div>
                                
                            :
                                null
                            }

                            {this.state.openNotificationModal ?
                                <NotificationModal show={this.state.openNotificationModal}
                                    notifyInfo={this.state.notificationItem}
                                    displayNextNotification = {this.displayNextNotification}
                                    gameInfo={() => this.props.gameInfo()}
                                    deleteNotification={(type) => this.deleteNotification(type)}
                                    onClose={() => this.closeNotificationModal()} 
                                    onNavigate={(pathname) => this.props.onNavigate(pathname)}
                                    processError = {(errorObj) => this.props.processError(errorObj)}
                                 />
                                :
                                null
                            }

                            {this.gameInfo.gamePhase === "2"  ?
                                <span>
                                    <GameSpinner
                                        startSpinner={this.state.gameSpinner}
                                        spinnerDisabled={this.state.cardDisabled}
                                        eventCategory={this.eventCategory}
                                        displayPointer={this.state.clickImageStartSw}
                                        onSpin={() => this.stopGameSpinner()}
                                    />
                                    <SpinnerLegend
                                        nbrSpins={this.gameInfo.cardList.length} 
                                        eventCategories={this.state.eventCategories}
                                        jobName={this.gameInfo.pictureInfo.jobName}
                                        screenSize={this.props.screenSize}
                                    />
                                </span>
                                :
                                null
                            }

                            {this.gameInfo.cardInProcess === true &&
                             this.gameInfo.currentCard.cardType  &&
                            !this.state.flipCard &&  
                            !this.state.gameSpinner &&
                                (this.state.validCardTypes.includes(this.gameInfo.currentCard.cardType) ||
                                    this.gameInfo.currentCard.cardType === "Activity") ?
                                <div>
                                    <GameCardFaceUp currentCard={this.gameInfo.currentCard}
                                        responseReceived={this.state.responseReceived}
                                        screenSize={this.props.screenSize}
                                        itemName={this.gameInfo.cardImageObj.itemName}
                                        onLastCard={(selectedType, activity) => this.lastCardDisplayed(selectedType, activity)}
                                        onComplete={(selectedInd) => this.resolveDisplayedCard(selectedInd)}
                                        calcResponseValue={(response) => this.calculateResponseValue(response)}
                                        onResultDisplay={() => this.onResultDisplay()}
                                    />
                                </div>
                                :
                                null
                            }

                            {this.gameInfo.cardImageObj.cardImage &&
                             !this.state.flipCard ?
                                <GameBoardImageDisplay
                                    imageName={this.gameInfo.cardImageObj.imageName}
                                    imageNameClass={this.gameInfo.cardImageObj.imageNamePosition}
                                    imageClass={this.gameInfo.cardImageObj.imagePosition}
                                    pictureSrc={this.gameInfo.cardImageObj.cardImageURL}
                                    imageClass2={this.gameInfo.cardImageObj.imageClass}
                                />
                            :
                                null
                            }

                            {this.gameInfo.cardInProcess === true &&
                             this.gameInfo.currentCard.cardType &&
                             !this.state.flipCard &&  
                             this.gameInfo.currentCard.cardType === "dialog" ?
                                <FriendDialogDisplay
                                    currentCard={this.gameInfo.currentCard}
                                    calcResponseValue={(response) => this.calculateResponseValue(response)}
                                    onResultDisplay={() => this.onResultDisplay()}
                                    onComplete={(selectedInd) => this.resolveDisplayedCard(selectedInd)}
                                />
                                :
                                null
                            }

                            {this.holidayDecoration ?
                                <GameBoardImageDisplay
                                    imageNameClass={""}
                                    imageClass={this.state.holidayObj.imagePosition}
                                    pictureSrc={this.state.holidayObj.imageURL}
                                    imageClass2={this.state.holidayObj.imageClass}
                                    />
             
                            :
                                null
                            }

                            {this.state.displayPurchases   ?
                                <DisplayPurchasesModal
                                    show={this.state.displayPurchases}
                                    purchaseTable={this.purchaseTable}
                                    onClose={() => this.displayPurchases("close")}
                                />
                            :
                                null
                            }

                            {this.state.awardModal   ?
                                <AwardModal modalOpen={this.state.awardModal} 
                                    gameInfo={this.gameInfo}
                                    playerSelected={true}
                                    onNavigate={(pathname) => this.props.onNavigate(pathname)}
                                    onClose={(parameter) => this.closeAwardModal(parameter)} 
                                />
                            :
                                null
                            }

                            {this.state.celebrationModal ? 
                                <CelebrationModal
                                    isOpen={this.state.celebrationModal}
                                    onClose={() => this.closeNotificationModal()}                        
                                    type={this.awardType}
                                    title={this.awardTitle}
                                    description={this.additionalText}
                                    imgSrc={this.imgSrc}
                                    trophyID={this.awardID}
                                />
                            :
                                null
                            }
                            
                            {this.state.earnBadge ?
                                <EarnBadge
                                    openChallenge={this.state.earnBadge}
                                    parameters={this.badgeParameters}
                                    nextBadge={this.nextBadge}
                                    gameInfo={this.gameInfo}
                                    onFinish={(badgeObj) => this.finishBadgeProcess(badgeObj)}
                                    onClose={() => this.closeBadge()}
                                    onNavigate={(pathname) => this.props.onNavigate(pathname)}
                                    setGameInfo = {(value, propertyName, subPropertyName) => 
                                        this.props.setGameInfo(value, propertyName, subPropertyName)}
                                    processError = {(errorObj) => this.props.processError(errorObj)}
                                />
                                : <span/>    
                            }

                            {this.state.gameSettings   ?
                                <ChangeGameSettingsModal 
                                    modalOpen={this.state.gameSettings}
                                    gamePhase={this.gameInfo.gamePhase}
                                    setGameInfo = {(value, propertyName, subPropertyName) => 
                                        this.props.setGameInfo(value, propertyName, subPropertyName)}
                                    onClose={() => this.changeGameSettings("close")}
                                    processError = {(errorObj) => this.props.processError(errorObj)}
                                />

                            :
                                null
                            }

                            <div className="unlocked-feature-roadmap-row">
                                {unlockedFeatureRoadmap}
                            </div>

                        </span>
                    }
            {/*
                      {process.env.NODE_ENV === 'development' && (
                        <div className="breakpoint-indicator" />
                        )}
            */}
                </div>
               
            </div>
        </>
    }

    componentDidMount() {
        this._isMounted = true;
        this.turnCount = this.props.gameInfo.turnCount;
        this.gameInfo.backgroundURL = this.gameInfo.pictureInfo.livingRoomImg;
        if (!this.gameInfo.timeWizardInfo.gameID || 
            this.gameInfo.timeWizardInfo.status === "inactive"){
                this.monthsPerTurn = 1;
        }else{
                this.monthsPerTurn = +this.gameInfo.timeWizardInfo.monthsPerTurn;
        }
        this.specialCardCount = 1;
        //  this happens before the gamePictureInfo storage is created by GameChoicePictures
        this.determineIfEndGame();
        this.setGamePhase("onMount"); 
  
        //  this is being saved to help resolve an intermittent problem with the dialogIndx
        //  not being updated
        this.beforeFriendList = JSON.parse(JSON.stringify(this.gameInfo.gameData.friendList));
        if (!this.gameInfo.cardList || 
            (this.gameInfo.cardList.length === 0  && this.gameInfo.cardInProcess !== true)){
            this.determineIfSpecialCardMonth();
            if (!this.gameInfo.currentCard.title ){
                if (this.gameInfo.gamePhase === "1") {
                    this.getNextEvents();
                }else{
                    this.setNextSpinnerCardList();
                }
            }
        }else{
            if (this.gameInfo.cardList.length > 0 || this.gameInfo.cardInProcess === true){
                if (this.gameInfo.cardList.length > 0){
                    this.checkCardList();
                    const maxIndx = this.gameInfo.cardList.length - 1;
                    this.eventCategory = this.gameInfo.cardList[maxIndx].eventCategory; 
                }else{
                    this.eventCategory = this.gameInfo.currentCard.eventCategory;
                    // this covers case where the last card has been displayed but not fully
                    // processed.
                    this.cardsReady = true;
                }
                if (this.gameInfo.cardInProcess === true){
                    this.setState({cardDisabled: true});
                }else{
                    this.gameInfo.cardImageObj = {};
                    this.props.setGameInfo(this.gameInfo.cardImageObj, "cardImageObj");
                }
                if (this.gameInfo.currentCard.backgroundType){
                    const imagesObj = 
                        determineBackgroundURL(this.gameInfo.currentCard.backgroundType, 
                            this.gameInfo.gameData.currentGameDate, 
                            this.gameInfo.gameData.conditionsTable, 
                            this.gameInfo.cardImageObj.cardImage, 
                            this.gameInfo.pictureInfo );
                    this.gameInfo.backgroundURL = imagesObj.backgroundURL;
                    this.props.setGameInfo(this.gameInfo.backgroundURL, "backgroundURL");
                    this.holidayDecoration = imagesObj.holidayDecoration;
                    this.setState({holidayObj: imagesObj.holidayObj});
                    this.gameInfo.cardImageObj.cardImage = imagesObj.cardImage;
                }
    
                //   the following triggers the click finger on the card hand
                if(this.state.timeout) clearTimeout(this.state.timeout);
                    this.state.timeout = setTimeout(() => {
                    this.setState({clickImageStartSw: true});
                }, 7000);
            }
        }
        this.props.setGameInfo(false, 'loading');
        this.notificationArr = this.props.notificationArr;
        this.checkForNewAchievements();
        this.createNotifications("update");
        if (this.notificationArr.length > 0) {
            this.openNotificationModal();
        }
        // this code is used to get the funStuff item image name
        this.backgroundName = "home";
        if (!this.gameInfo.cardImageObj.cardImage  &&
            this.gameInfo.cardInProcess === true){
            this.buildCardImageObj();
        }
        this.awardButtonClass = "badge-btn badge-border";
        this.defaultAwardButtonClass = this.awardButtonClass;
        this.props.calcMoodRetirementScores();
        const newAward = sessionStorage.getItem("newAwardEarned");
        if (newAward && newAward === "true"){
             this.awardButtonClass += " cta-pulse";
             sessionStorage.removeItem("newAwardEarned");
        }
        const nextBadgeObj = determineNextBadge(this.gameInfo.gameData.badgesEarned);
        this.nextBadge = nextBadgeObj.nextBadge;
        this.badgeParameters = nextBadgeObj.badgeParameters
        const gameSettings = this.props.gameSettings;
        this.gameSettingsFlipCard = gameSettings.flipCard;
        this.gameSettingsGameSpinner = gameSettings.gameSpinner;
        // this.setState({flipCard: gameSettings.flipCard});
        this.setState({trainAnimation: gameSettings.trainAnimation});
        if (gameSettings.trainAnimation === false){
            this.setState({nextTurn: false});
        }
   
        const imagesObj = determineBackgroundURL("home", 
            this.gameInfo.gameData.currentGameDate, this.gameInfo.gameData.conditionsTable, 
            this.gameInfo.cardImageObj.cardImage, this.gameInfo.pictureInfo );
        this.holidayDecoration = imagesObj.holidayDecoration;
        this.setState({holidayObj: imagesObj.holidayObj});
  
        this.nbrMonthsPlayed = +this.props.totalNbrGameMonths - +this.gameInfo.gameData.gameNbrMonths;
        if (this.gameInfo.gameData.unlockedFeatures.length > 0){
            this.unlockedFeaturesRoadmapArr = 
                createUnlockedFeatureRoadmapArr(this.gameInfo.gameData.unlockedFeatures, 
                    this.nbrMonthsPlayed, this.gameInfo.gameData.currentCash,
                    this.gameInfo.savingsInfo, this.monthlyIncome, this.props.creditReport, 
                    this.gameInfo.gameData.assetTable, this.gameInfo.gameData.currentGameDate, 
                    this.gameInfo.summaryInvestment, this.gameInfo.funStuffInfo, this.gameInfo.creditCardInfo,
                    this.gameInfo.timeWizardInfo, true);
        }
    }

    checkCardList(){
        const newCardList = replaceInvalidCardEvents(this.gameInfo.cardList,
            this.gameInfo.gameData.conditionsTable,
            "conditionArr", this.gameInfo.gamePhase );
        this.gameInfo.cardList = JSON.parse(JSON.stringify(newCardList));
        this.props.setGameInfo(this.gameInfo.cardList, 'cardList');
    }

    checkForNewAchievements(){
        const creditScore = this.props.creditReport.creditScore;
        const newAchievementArr = checkForAchievements(this.gameInfo.gameData, this.gameInfo.savingsInfo,
            this.gameInfo.creditCardInfo, this.props.summaryInvestment, this.props.investmentMaster,
            this.nbrMonthsPlayed, creditScore, this.monthsPerTurn, this.props.moneyMgmtTestArr,
            this.gameInfo.timeWizardInfo, "gameDataStartUp" )
        if (newAchievementArr.length > 0){
            for (let i=0; i<newAchievementArr.length; i++){
                let achievementObj = newAchievementArr[i];
                const notificationObj = addCelebrationToNotificationArr(achievementObj.achievementID,
                   "achievement", achievementObj.achievementTitle ); 
                this.notificationArr.push(notificationObj);
            }
        }  
    }

    componentWillUnmount() {
         // this.props.setGameInfo(this.gameInfo.gameData, "gameData");
        clearInterval(this.state.timeout);
        this.props.setGameInfo("game-board", "prevProcess");
        this.props.setGameInfo(this.notificationArr, "notificationArr");
        // fix Warning: Can't perform a React state update on an unmounted component
        this.setState = (state,callback)=>{
            return;
        };
    }

    // SECTION:  general processes

    savePointerPosition(positionObj){
        this.right = +positionObj.right  - 205 + "px";
        this.bottom = +positionObj.bottom  + 3 + "px";
    }

    trainVideoDone(){
        this.setState({nextTurn: false});
    }

    changeGameSettings(action){
        if (action === "open"){
            this.setState({gameSettings: true});
        }
        if (action === "close"){
            this.gameInfo.gameData.gameSettings = this.props.gameSettings;
            const gameSettings = this.props.gameSettings;
            this.gameSettingsFlipCard = gameSettings.flipCard;
            this.gameSettingsGameSpinner = gameSettings.gameSpinner;
            this.setState({gameSettings: false,
                trainAnimation: gameSettings.trainAnimation
            });
            if (gameSettings.trainAnimation === false){
                this.setState({nextTurn: false});
                this.cardsReady = true;
            }
        }
    }
   
    determineIfEndGame() {
        let endGameReason = "";
        if (+this.gameInfo.gameData.nbrMonthsNegative >= +ConfigFile.gameBoard.nbrMonthsNegative) {
            endGameReason = "NegativeCash";
        }
        if (+this.gameInfo.gameData.nbrMonthsMoodNegative >= +ConfigFile.gameBoard.nbrMonthsMoodNegative) {
            endGameReason = "NegativeMoodPoints";
        }
        if (+this.gameInfo.gameData.gameNbrMonths <= +0) {
            endGameReason = "TimeElapsed";
        }
        if (endGameReason !== "") { 
            this.props.onEnd(endGameReason);
            this.props.onNavigate("end-game");
        }
    }

    setGamePhase() {
        let changeGamePhase = false;
        let gameMonth = this.props.totalNbrGameMonths - +this.gameInfo.gameData.gameNbrMonths;
        if (this.gameInfo.gamePhase === "") {
            // gamePhase is always spaces onMount
            if (gameMonth < 60) {
                this.gameInfo.gamePhase = "1";
            } else {
                this.gameInfo.gamePhase = "2";
                if (this.gameInfo.gameData.iconTable[0].iconName === "gameBasicHelp") {
                    this.updateHelpIcon = true;
                    changeGamePhase = true;
                }
            }
        } else {
            if (this.gameInfo.gamePhase === "1" && gameMonth >= 60) {
                changeGamePhase = true;
                this.gameInfo.gamePhase = "2";
                this.updateHelpIcon = true;
            }
        }
        if (changeGamePhase === true) {
            this.props.setGameInfo(this.gameInfo.gamePhase, "gamePhase");
            this.setState({responseReceived: false});
            this.gameInfo.gameData.hand.splice(0); // erase any/all cards left in the hand
        }
    }

    createNotifications(updateInd) {
        if (!this.notificationArr){
            this.notificationArr = [];
        }
        let incomeObj = calcMonthlyIncome(this.gameInfo.gameData.assetTable, 
            this.gameInfo.gameData.expenseTable, this.gameInfo.gameData.loanTable);
        this.monthlyIncome = incomeObj.income;
        let cashAmt = this.gameInfo.gameData.currentCash;
        //  parse and stringify creates a new copy of the iconTable (instead of using same dataSpace)
        let iconTable = JSON.parse(JSON.stringify(this.gameInfo.gameData.iconTable));
        //  the following just retrieves the rent expense and does not remove it (last parm is false)
        let moneyMgmtTest = true;
        if (this.gameInfo.moneyMgmtTestArr.length === 0 ||
            this.gameInfo.moneyMgmtTestArr[0].testType === "none" ){
                moneyMgmtTest = false;
        }
        let rentExpenseObj = findRemoveTableItem(this.gameInfo.gameData.expenseTable, "rent", false);
        const newIconTable = checkIconTableEntries(iconTable, cashAmt, this.gameInfo.savingsInfo,
            this.monthlyIncome, this.gameInfo.gameData.currentMoodPoints, this.gameInfo.gameData.pendingJob,
            this.gameInfo.creditCardInfo, this.gameInfo.gameData.conditionsTable,
            this.gameInfo.gameData.gameNbrMonths, this.gameInfo.gameData.unlockedFeatures,
            rentExpenseObj.expAmount, moneyMgmtTest, this.props.totalNbrGameMonths,
            this.props.eligibleForCouponsDividends);
        let updateIconTable = false;
        if (newIconTable.length !== this.gameInfo.gameData.iconTable.length){
            updateIconTable = true;
        }else{
            for (let i=0; i<newIconTable.length; i++){
                if (newIconTable[i] !== this.gameInfo.gameData.iconTable[i]){
                    updateIconTable = true;
                    break;
                }
            }
        }
        if (updateIconTable === true){
            this.gameInfo.gameData.iconTable = newIconTable;
            if (updateInd === "update"){
                this.updateIconTable();
            }
        }
        if (this.updateHelpIcon === true) {
            this.gameInfo.gameData.iconTable[0].iconName = "gameBasicHelp2";
            this.gameInfo.gameData.iconTable[0].firstTime = true;
            this.updateHelpIcon = false;
        }
     
        //  this process creates the notification array and updates iconTable
        //  change firstTime indicator to false
        const notificationArr = createNotificationsFromIconTable(this.gameInfo.gameData.iconTable);
        if (notificationArr.length > 0){
            this.notificationArr = this.notificationArr.concat(notificationArr);
        }
    }
    
    finishBadgeProcess(badgeObj){
        const nextBadgeObj = determineNextBadge(badgeObj.badgesEarned);
        this.nextBadge = nextBadgeObj.nextBadge;
        this.badgeParameters = nextBadgeObj.badgeParameters;
        const lastIndx = badgeObj.badgesEarned.length - 1;
        const newBadgeObj = badgeObj.badgesEarned[lastIndx];
        const notificationObj = 
            addCelebrationToNotificationArr(newBadgeObj.badgeCode, "badge", "", newBadgeObj);  
        this.notificationArr = [notificationObj];
        this.openNotificationModal();
        this.setState({earnBadge: false,  cardDisabled: false}); 
    }

    awardAnimationEnd() {
        this.awardButtonClass = this.defaultAwardButtonClass;
    }
    
    openAwardModal(){
        this.setState({awardModal: true});
    }

    closeAwardModal(parameter){
        this.setState({awardModal: false});
        if (parameter === "earn-badge"){
            this.setState({earnBadge: true});
        }
    }

    closeBadge(){
        this.setState({earnBadge: false});
    }
    
    displayCelebrationModal(notificationObj){
        this.awardType = notificationObj.awardType;
        this.awardID = notificationObj.awardID;
        this.awardTitle = notificationObj.awardTitle;
        this.imgSrc = notificationObj.imgSrc;
        this.additionalText = notificationObj.additionalText; 
        this.setState({celebrationModal: true});   
    }
    
    openNotificationModal(iconName) {
        //  if iconName is valid, it means that a person has clicked on an icon
        //  in the icon display area
        if (iconName) {
            this.notificationArr = [];
            for (let i = 0; i < this.gameInfo.gameData.iconTable.length; i++) {
                let iconTable = this.gameInfo.gameData.iconTable[i];
                if (iconTable.iconName === iconName) {
                    const notificationType = determineNotificationType(iconTable);
                    let notificationObj = {variety: "notification", category: iconTable.iconCategory,
                        type: notificationType, additionalInfo: iconTable.additionalInfo,
                        imageSrc: iconTable.imageSrc
                    };
                    this.notificationArr.push(notificationObj);
                    break;
                }
            }
            this.updateFirstTimeInd = false;
        }else{
            this.updateFirstTimeInd = true;
        }

        const notificationItem = this.notificationArr[0];
        this.displayNextNotification = true;
        this.setState({notificationItem: notificationItem});
   
        if (notificationItem.variety === "notification"){
            this.setState({openNotificationModal:  true});
        }
        if (notificationItem.variety === "celebration"){
            this.displayCelebrationModal(notificationItem);
        }
    }

    deleteNotification(notificationType){
        const notifyIndx = this.notificationArr.findIndex(elem => elem.type === notificationType);
        if (notifyIndx !== -1){
            this.notificationArr.splice(notifyIndx, 1);
        }
        this.props.setGameInfo(this.notificationArr, "notificationArr");
    }

    closeNotificationModal() {
        let notificationArr = this.notificationArr;
        const notificationVariety = notificationArr[0].variety;
        if (this.updateFirstTimeInd === true){};
        notificationArr.splice(0, 1);
  
        if (notificationArr.length === 0) {
            if (notificationVariety === "notification"){
                this.setState({openNotificationModal: false, notificationItem: {}});
                this.displayNextNotification = false;
            }else{
                this.awardButtonClass = this.defaultAwardButtonClass;
                this.awardButtonClass += " cta-pulse";
                this.setState({celebrationModal: false});
            }
            if (this.state.pendingEndGame === true){
                this.props.onEnd(this.endGameReason);
                this.props.onNavigate("end-game");
            } 
        }else{
            this.setState({notificationItem: notificationArr[0]});
            if (notificationArr[0].variety === "notification"){
                this.setState({openNotificationModal: true, celebrationModal: false});
                this.displayNextNotification = true;
            }else{
                this.setState({openNotificationModal: false});
                this.displayCelebrationModal(notificationArr[0]);
            }
        }
    }

    displayPurchases(openClose){
        if (openClose === "open"){
            this.addTotalsLineToPurchaseTable();
            this.setState({displayPurchases: true});
        }else{
            this.setState({displayPurchases: false});
        }
    }

    addTotalsLineToPurchaseTable(){
        this.purchaseTable = JSON.parse(JSON.stringify(this.gameInfo.gamePurchases.purchaseTable));
        this.totalItemCost = 0;
        for (let i=0; i<this.purchaseTable.length; i++){
              let purchase = this.purchaseTable[i];
              this.totalItemCost += +purchase.itemCost;
        }
        const purchaseObj = {imageURL: "dollarSign.png", itemCost: this.totalItemCost, 
            itemName: "Total Cost of Purchases"};
        this.purchaseTable.push(purchaseObj);
    }

    processNextCard() {
        clearInterval(this.state.timeout);
        this.setState({clickImageStartSw: false});
        if (this.state.cardDisabled === false || this.flipNextCard === true) {
            this.flipNextCard = false;
            this.setState({cardDisabled: true});
            if (this.gameInfo.gamePhase === "1"){
                if (this.gameSettingsFlipCard === true){
                    this.setState({flipCard: true});
                }else{
                    this.displayNextCard();
                }
            }else{
                if (this.gameSettingsGameSpinner === true){
                    this.setState({gameSpinner: true});
                }else{
                    this.displayNextCard();
                }
            }
        }
    }

    stopFlipCard(){
        this.setState({flipCard: false});
        this.displayNextCard();
    }
    
    stopGameSpinner(){
        this.setState({gameSpinner: false});
        this.displayNextCard();
    }

    displayNextCard() {
        this.gameInfo.currentCard = this.gameInfo.cardList.pop();
        this.cardTitle = this.gameInfo.currentCard.title;
        this.props.setGameInfo(this.gameInfo.currentCard, "currentCard");
        this.props.setGameInfo(this.gameInfo.cardList, "cardList");
        if (this.gameInfo.cardList.length === 0 &&
            this.gameInfo.currentCard.cardType === "Activity")
        {
            this.checkForInSchoolCondition();
        }
        this.gameInfo.cardInProcess = true;
        this.props.setGameInfo(this.gameInfo.cardInProcess, "cardInProcess");
        this.setState({cardDisabled: true});
        if (this.gameInfo.currentCard.cardType === "dialog") {
            this.getFriendURL();
        }
        this.props.setGameInfo(this.gameInfo.cardList, 'cardList');
        this.getCardImage();
        this.setState({responseReceived: false});
    }

    getFriendURL() {
        console.log("getFriendURL process")
        const friendName = this.gameInfo.friendCardInfo.friendName;
        console.log("friendCardInfo: ", this.gameInfo.friendCardInfo);
        const friendIndx = this.gameInfo.friendInfo.findIndex(elem => elem.friendName === friendName);
        this.gameInfo.currentCard.friendImgURL = this.gameInfo.friendInfo[friendIndx].friendImgURL;
        const friendsTable = this.gameInfo.gameData.friendList;
        const gameFriendIndx = friendsTable.findIndex(elem => elem.name === friendName);
        if (friendsTable[gameFriendIndx].introDate === "") {
            friendsTable[gameFriendIndx].introDate = this.gameInfo.gameData.currentGameDate;
        }
        friendsTable[gameFriendIndx].dialogIndx = this.gameInfo.friendCardInfo.dialogIndx;
        this.gameInfo.gameData.friendList = friendsTable;
        this.props.setGameInfo(this.gameInfo.gameData.friendList, "gameData", "friendList");
        this.saveFriendIndx = gameFriendIndx;
        console.log("save friend indx: ", this.saveFriendIndx);
        if (this.gameInfo.gameData.friendList[this.saveFriendIndx].dialogIndx ===
            this.beforeFriendList[this.saveFriendIndx].dialogIndx){
                //  trying to resolve an intermittent issue where the dialog index
                //  is not getting updated
                if (this.gameInfo.gameData.user === "student8"){
                    alert ("friend dialog index not updated error log " +
                        "being created review console messages."
                    )
                }
                const errorDesc = "dialog index not updated - getFriendURL";
                const gameFriend = this.gameInfo.gameData.friendList[this.saveFriendIndx];
                const friendCardInfo = this.props.gameInfo.friendCardInfo;
                const errorObj = {player: this.gameInfo.gameData.user, friendIndx: this.saveFriendIndx,
                    friendName: gameFriend.name, dialogIndx: gameFriend.dialogIndx,
                    cardTitle: this.gameInfo.currentCard.title, 
                    reduxFriendCardInfo: friendCardInfo,
                    beforeFriend: this.beforeFriendList[this.saveFriendIndx],
                    updatedFriend: this.gameInfo.gameData.friendList[this.saveFriendIndx]}; 
                this.generalErrorLog(errorDesc, errorObj);          
        }
        this.changeFriendList = JSON.parse(JSON.stringify(this.gameInfo.gameData.friendList));
    }

    checkForInSchoolCondition() {
        let noActivityOptions = false;
        const conditionObj = 
            this.gameInfo.gameData.conditionsTable.findLast(elem => elem.conditionClass === "college");
        if (conditionObj){
            if (conditionObj.condName !== "in-college"){
                noActivityOptions = true;
            }
        }
        if (noActivityOptions === true) {
            let descriptionText =
                "You are in college and have an upcoming exam or term paper " +
                "that is due.  You will not be able to do any extra activities " +
                "at this time.";
            let lastCardButtons = [{ type: "Regular", btnText: "Continue the Game" }];

            this.gameInfo.currentCard.description = descriptionText;
            this.gameInfo.currentCard.lastCardButtons = lastCardButtons;
        }
    }

    setNextSpinnerCardList(){
       
        if (!this.gameInfo.cardList || this.gameInfo.cardList.length === 0) {
            if (this.gameInfo.cardList.length === 0){
                if (this.state.trainAnimation === true){
                    this.setState({nextTurn: true});
                }
            }
            let nbrCards = calcRandomNumberWithMax(3, false);
            nbrCards = +nbrCards + 4;
            let nbrArray = [1, 2, 3, 5, 6, 7];
            let randomArr = shuffleArray(nbrArray);
            this.eventNbrArr = [8];
            for (let i = 0; i < nbrCards; i++) {
                this.eventNbrArr.push(randomArr[i]);
            }
            let nonCardEvents = [4, 6, 8];
            if (this.badgeMonth === true){
                //  if it is a badge month, then do not need to get a type 7 ("other") event
                nonCardEvents.push(7);
                // add badge event ("7") to the array
                if (this.eventNbrArr.includes(7)){
                   //  no action required, 7 is already in the event array  
                }else{
                   let index = this.eventNbrArr.length - 2; 
                   this.eventNbrArr.splice(index, 0, 7);  
                }
            }
            if (this.friendMonth === true){
                // adding friend event ("4") to the array in a random place
                let randomNbr = calcRandomNumberWithMax(nbrCards, false) + 1;
                this.eventNbrArr.splice(randomNbr, 0, 4);  // add number 4 to array in 'randomNbr' position
            }

            if (this.eventNbrArr.includes(6)){
                this.jokeCard = true;
            }
          
            this.eventCategoryArr = [];
            for (let i=0; i<this.eventNbrArr.length; i++){
                if (nonCardEvents.includes(this.eventNbrArr[i])){
                    //  skip these events they will be created by process
                }else{
                    const eventCategory = EventCategoryList.find(elem => elem.number === this.eventNbrArr[i]);
                    if (eventCategory){
                        this.eventCategoryArr.push(eventCategory.category);
                    }
                }
            }
            this.getNextSpinnerCardList();
        }
    }

    getCardImage() {
        const imagesObj = determineBackgroundURL(this.gameInfo.currentCard.backgroundType, 
            this.gameInfo.gameData.currentGameDate, this.gameInfo.gameData.conditionsTable, 
            this.gameInfo.cardImageObj.cardImage, this.gameInfo.pictureInfo );
        this.gameInfo.backgroundURL = imagesObj.backgroundURL;
        this.holidayDecoration = imagesObj.holidayDecoration;
        this.setState({holidayObj: imagesObj.holidayObj});
        this.gameInfo.cardImageObj.cardImage = imagesObj.cardImage;
        this.props.setGameInfo(this.gameInfo.backgroundURL, "backgroundURL");
        if (this.gameInfo.currentCard.description.includes("||level2Job") ||
            this.gameInfo.currentCard.description.includes("||level3Job")) {
                this.insertJobLevelTextInCard();
        }
        this.backgroundName = this.gameInfo.currentCard.backgroundType;
        this.buildCardImageObj();
    }

    buildCardImageObj(){
        let mainDirectory = "";
        if (this.gameInfo.currentCard.imageDir && 
            this.gameInfo.currentCard.imageDir.length > 0){ 
            const imageDirArr = this.gameInfo.currentCard.imageDir.split('-');
            mainDirectory = imageDirArr[0];
        }
        if (mainDirectory === "friends" || mainDirectory === "friendThrifty" || 
            mainDirectory === "friendSpender"){
            this.gameInfo.cardImageObj = determineWhichFriendToDisplay(mainDirectory, 
                this.gameInfo.gameData.friendList, this.gameInfo.friendInfo, this.gameInfo.currentCard, 
                this.gameInfo.gameData.currentGameDate, 
                this.gameInfo.gamePurchases.purchaseTable);
            this.gameInfo.currentCard = {...this.gameInfo.currentCard, 
                friendName: this.gameInfo.cardImageObj.friendName};
        }else{
            this.gameInfo.cardImageObj = determineImageURL(this.gameInfo.currentCard, 
                this.gameInfo.funStuffInfo.itemArr, this.backgroundName, 
                this.gameInfo.gamePurchases.purchaseTable);
            if (this.gameInfo.cardImageObj.purchaseItem === true &&
                this.gameInfo.cardImageObj.pictureError !== ""){
                // this is a very intermittent bug that may have been resolved
                // putting in a silent log to determine if it is still
                const errorDesc = this.gameInfo.cardImageObj.pictureError;
                const errorObj={user: this.gameInfo.gameData.user,
                    purchaseInfo: this.gameInfo.purchaseInfo,
                    conditionTable: this.gameInfo.gameData.conditionTable};
                this.generalErrorLog(errorDesc, errorObj);
            }
        }
        this.props.setGameInfo(this.gameInfo.cardImageObj, "cardImageObj");
    }

    insertJobLevelTextInCard() {
        let searchString = "";
        let stringData = "";
        if (this.gameInfo.currentCard.description.includes("||level2Job")) {
            searchString = "level2Job";
            stringData = this.gameInfo.pictureInfo.jobLevel2;
        } else {
            searchString = "level3Job";
            stringData = this.gameInfo.pictureInfo.jobLevel3;
        }
        let replaceObj = { string: stringData };
        this.gameInfo.currentCard.description =
            replaceTextInString(this.gameInfo.currentCard.description, replaceObj, searchString, "string");
    }

    lastCardDisplayed(selectedType, selectedActivity) {
        if (this.state.eventTracker === true){
            this.beforeGameData = JSON.parse(JSON.stringify(this.gameInfo.gameData));
        }
        this.gameInfo.cardInProcess = false;
        this.props.setGameInfo(this.gameInfo.cardInProcess, "cardInProcess");
        this.estimatedMonthlyExp = 0;
        
        if (this.state.eventTracker === true){
            this.beforeGameData = JSON.parse(JSON.stringify(this.gameInfo.gameData));
        }
        this.gameInfo.cardInProcess = false;
        this.props.setGameInfo(this.gameInfo.cardInProcess, "cardInProcess");
        let creditCardActive = false;
        if (this.gameInfo.creditCardInfo.gameID){
            if (this.gameInfo.creditCardInfo.totalOutstandingBalance > 0 ||
                this.gameInfo.creditCardInfo.currentlyActive === true){
                    creditCardActive = true;
            }
        }
        this.turnCloseOutObj = closeOutThisTurn(this.gameInfo.gameData,  this.props.totalNbrGameMonths,
            this.gameInfo.timeWizardInfo, this.gameInfo.savingsInfo, this.monthsPerTurn, 
            creditCardActive, this.props.investmentMaster, this.props.gameInvestments);
        this.nbrMonthsPlayed = +this.props.totalNbrGameMonths - +this.gameInfo.gameData.gameNbrMonths;
        if (this.turnCloseOutObj.notificationArr.length > 0){
            this.notificationArr = this.notificationArr.concat(this.turnCloseOutObj.notificationArr);
        }
        this.completeEndOfTurnUpdates();
        this.props.setGameInfo(this.gameInfo.gameData, "gameData");
        //   game date has been rolled forward
        this.setGamePhase("lastCard");
        this.skipNotificationCheck = false;
        if (selectedType === "Activity"){
            //  this means that the player has selected to go to activities 
            //  notifications will be processed when they return from activities
            this.skipNotificationCheck = true;
        }
        this.processEndOfTurn();
        if (this.state.eventTracker === true){
            this.createLastCardEventTracker(selectedType);
        }
        this.prepareForNextTurn();
        if (selectedType === "Activity") {
            const activityCategory = 
                {detail: selectedActivity, totalNbrGameMonths: this.props.totalNbrGameMonths};
            this.props.setGameInfo(activityCategory, "activityCategory");
            this.props.onNavigate("select-activity");
        }
        if (+this.gameInfo.gameData.gameNbrMonths <= 0) {
            let endGameReason = "TimeElapsed";
            if (this.notificationArr.length > 0){
                this.endGameReason = endGameReason;
                this.setState({pendingEndGame: true});
            }else{
                this.props.onEnd(endGameReason);
                this.props.onNavigate("end-game");
            }
        }
        const imagesObj = determineBackgroundURL("home", 
                this.gameInfo.gameData.currentGameDate, 
                this.gameInfo.gameData.conditionsTable, 
                this.gameInfo.cardImageObj.cardImage, 
                this.gameInfo.pictureInfo );
        this.gameInfo.backgroundURL = imagesObj.backgroundURL;
        this.props.setGameInfo(this.gameInfo.backgroundURL, "backgroundURL");
        this.holidayDecoration = imagesObj.holidayDecoration;
        this.setState({holidayObj: imagesObj.holidayObj, responseReceived: false});
    }

    completeEndOfTurnUpdates(){
        if (this.turnCloseOutObj.gameInvestUpdtArr.length > 0){
            for (let i=0; i<this.turnCloseOutObj.gameInvestUpdtArr.length; i++){
                let indx = this.turnCloseOutObj.gameInvestUpdtArr[i];
                this.updateGameTransactions(this.turnCloseOutObj.gameInvestments[indx]);
            }
            this.props.setGameInfo(this.gameInfo.gameInvestments, "gameInvestments");
            if (this.gameInfo.gameInvestments.length > 0){
                this.props.updateInvestmentSummary();
            }
        }
        if (this.turnCloseOutObj.updateSavings === true){
            this.savingsBodyObj = {savingsObj: this.gameInfo.savingsInfo, 
                savingsTranArr: this.turnCloseOutObj.savingsTranArr, 
                currentPriceArr: this.turnCloseOutObj.currentPriceArr };
            this.updateSavings(this.turnCloseOutObj.archiveSavingTrans);
        }
        this.updateEndOfTurnCash();
        this.props.setGameInfo(this.gameInfo.gameData, "gameData");
    }

    updateEndOfTurnCash(){
        let monthlyCashAmt = +this.turnCloseOutObj.monthlyCashAmt;
        if (isNaN(monthlyCashAmt)){
            const errorDesc = "monthlyAmounts totalCashChange is NaN - processEndOfTurn";
            const errorObj = {monthlyAmountsCash: monthlyCashAmt } 
            this.generalErrorLog(errorDesc, errorObj);   
            monthlyCashAmt = 0;
        }
        let investCashAmt = +this.turnCloseOutObj.investCashAmt;
        if (isNaN(investCashAmt)){
            const errorDesc = "investCashAmt is NaN - processEndOfTurn";
            const errorObj = {investCashAmt: investCashAmt} 
            this.generalErrorLog(errorDesc, errorObj);   
            investCashAmt = 0;
        }
        let savingsCashAmt = +this.turnCloseOutObj.savingsCashAmt;
        if (isNaN(savingsCashAmt)){
            const errorDesc = "savingsCashAmt is NaN - processEndOfTurn";
            const errorObj = {savingsCashAmt: savingsCashAmt} 
            this.generalErrorLog(errorDesc, errorObj);   
            savingsCashAmt = 0;
        }
        let federalTaxAmt = +this.turnCloseOutObj.federalTaxAmt;
         if (isNaN(federalTaxAmt)){
            const errorDesc = "federalTaxAmt is NaN - processEndOfTurn";
            const errorObj = {federalTaxAmt: federalTaxAmt} 
            this.generalErrorLog(errorDesc, errorObj);   
            federalTaxAmt = 0;
        }
        
        this.cashAmt = (+this.gameInfo.gameData.currentCash + +monthlyCashAmt +
            +investCashAmt + +savingsCashAmt + +federalTaxAmt ).toFixed(2);   
        this.gameInfo.gameData.currentCash = this.cashAmt.toString();
        if (this.turnCloseOutObj.invalidArr.length > 0){
              const errorDesc = "spending amount values invalid - processEndOfTurn";
              const errorObj = {spendingHistoryInvalidArr: this.turnCloseOutObj.invalidArr};
              this.generalErrorLog(errorDesc, errorObj);
        } 
    }

    createLastCardEventTracker(selectedType){
        this.checkTablesAboutToExpire();
        this.expenseAmtChange = 0;
        let expenseTable = JSON.parse(JSON.stringify(this.beforeGameData.expenseTable));
        if (selectedType === "LifeStyle"){
            let tableItemChanged = findRemoveTableItem(expenseTable, "misc", false, "shortName");
            if (tableItemChanged){
                this.expenseAmtChange = tableItemChanged.expAmount - this.estimatedMonthlyExp;
            }
        }
        this.creditCardActive = false;
        this.nonCreditCardExpense = 0;
        //  the following is true if there are some properties in the creditCardInfo object
        if (Object.keys(this.gameInfo.creditCardInfo).length !== 0){
            if (this.gameInfo.creditCardInfo.totalOutstandingBalance > 0 ||
                this.gameInfo.creditCardInfo.currentlyActive === true){
                    this.creditCardActive = true;
                    this.creditCardBalance = this.gameInfo.creditCardInfo.totalOutstandingBalance;
                    let periodIdx = this.gameInfo.creditCardInfo.periodCreditCharges.length - 2;
                    this.creditCardMinPayment = 
                        this.gameInfo.creditCardInfo.periodCreditCharges[periodIdx].periodAmtPaid;        
                    this.calcNonCreditCardExpense();
            }
        }
        let eventTrackerArr = [];
        if (this.state.eventTracker === true){
            const dataObject = {expenseAmtChange: this.expenseAmtChange,
                    expireTable: this.expireTableArr,
                    monthsPerTurn: this.monthsPerTurn,
                    creditCardActive: this.creditCardActive,
                    moodPoints: this.additionalMoodPoints, 
                    creditCardBalance: this.creditCardBalance, 
                    creditCardMinPayment: this.creditCardMinPayment, 
                    nonCreditCardExpenses: this.nonCreditCardExpense
                    };
            let eventDetail = updateEventArr("LastCard", dataObject);
            eventTrackerArr.push(eventDetail);
            if (this.taxChange === true){
                eventDetail = updateEventArr("TaxChange", this.oldExpenseItem, this.gameInfo.gameData,
                    this.gameInfo.savingsInfo, this.gameInfo.currentCard)
            }
            this.eventTrackerArr.push(eventDetail);
            this.addToEventTracker(eventTrackerArr);
        }
    }

    checkTablesAboutToExpire(){
        this.expireTableArr = [];
        for (let i=0; i<this.gameInfo.gameData.assetTable.length; i++){
            const asset = this.gameInfo.gameData.assetTable[i];
            if (+asset.assetNbrMonths === 0){
                const assetTableObj={tableType: "asset", tableAmt: asset.assetAmt, itemType: asset.assetItem,
                    itemDesc: asset.assetDesc};
                this.expireTableArr.push(assetTableObj);
            }
        }
        for (let i=0; i<this.beforeGameData.expenseTable.length; i++){
            const expense = this.beforeGameData.expenseTable[i];
            // expNbrMonths compare s/b 1 (not 0) because we are checking the before table
            if (+expense.expNbrMonths === 1){
                const expenseTableObj={tableType: "expense", tableAmt: expense.expAmount, itemType: expense.expItem,
                    itemDesc: expense.expDesc};
                this.expireTableArr.push(expenseTableObj);
            }
        }
        for (let i=0; i<this.gameInfo.gameData.loanTable.length; i++){
            const loan = this.gameInfo.gameData.loanTable[i];
            if (+loan.loanNbrMonths === 0){
                const loanTableObj={tableType: "loan", tableAmt: loan.loanAmt, itemType: loan.loanType,
                    itemDesc: loan.loanDesc};
                this.expireTableArr.push(loanTableObj);
            }
        }
    }

    calcNonCreditCardExpense(){
        this.nonCreditCardExpense = 0;
        for (let i=0; i<this.gameInfo.gameData.expenseTable.length; i++){
            let expense = this.gameInfo.gameData.expenseTable[i];
            if (+expense.expNbrMonths !== 0 && expense.chargeCreditCard === false){
                this.nonCreditCardExpense += +expense.expAmount;
            }
        }
        this.nonCreditCardExpense = this.nonCreditCardExpense.toString();
    }

    prepareForNextTurn(){
        this.props.incrementTurnCount();
        this.turnCount = this.props.gameInfo.turnCount;
        // remove all remaining cards from cardList
        this.gameInfo.cardList.splice(0);
        // the following is done to remove the last card from 'hand' of gamedata
        this.gameInfo.gameData.hand.splice(0);
        this.gameInfo.cardImageObj = determineImageURL("",this.gameInfo.funStuffInfo.itemArr, "home");
        
        this.props.setGameInfo(this.gameInfo.cardImageObj, "cardImageObj");
        this.determineIfSpecialCardMonth();
        if (this.gameInfo.gamePhase === "1") { 
            this.getNextEvents();
        } else {
            this.setNextSpinnerCardList();
        }
        let currentMonthDate = dateStrToPlainText(this.gameInfo.gameData.currentGameDate);
        let currentMonthDateArr = currentMonthDate.split(" ");
        const currentMonth = currentMonthDateArr[0];
        let gameMonthsObj = {prevMonth: this.gameInfo.prevNextMonth.currentMonth, currentMonth: currentMonth};
        this.gameInfo.prevNextMonth = gameMonthsObj;
        this.prevMonth = this.gameInfo.prevNextMonth.prevMonth;
        this.props.setGameInfo(gameMonthsObj, "prevNextMonth");
        //  the following storage is used when returning from an 'activity'
        if (this.state.trainAnimation === true){
            this.setState({nextTurn: true});
        }
        this.cardsReady = false;
    }
    
    determineIfSpecialCardMonth(){
        var remainder;
        var divisor;
        this.friendMonth = false;
        if (this.monthsPerTurn === 1 || this.monthsPerTurn === 2){
            // friend will occur every other turn 
            divisor = 2;
            remainder = +this.turnCount  % divisor;
            if (remainder === 0) {
                this.friendMonth = true;
                this.specialCardCount += 1;
            }
        }else{
            // friend will occur every turn
            
            this.friendMonth = true;
            this.specialCardCount += 1;
        }

        if (this.friendMonth === true){
            console.log("!!!this is a friend month!!!");
        }
           
        this.jokeCard = false;
        if (+this.turnCount < this.state.jokeCardBeginMonth) {
            let remainder = +this.turnCount % 4;
            // joke card every 4th turn
            if (remainder === 0) {
                this.jokeCard = true;
                this.specialCardCount += 1;
            }
        }
        let badgesCount = this.gameInfo.gameData.badgesEarned.length / 2;
        if (badgesCount < this.state.maxNbrBadges){
            this.determineIfBadgeMonth();
        }
    }

    createLivingExpenseObj(){
        this.estimatedMonthlyExp = this.turnCloseOutObj.estimatedMonthlyExp;
        this.additionalMoodPoints = this.turnCloseOutObj.additionalMoodPoints;
        let expDesc = "Food, Clothes, Personal Items, etc."
        this.updateExpense("Misc Expenses", "flat", this.estimatedMonthlyExp, "-1", "", "", expDesc, true);
        // update mood points as a result of lifestyle choice
        calculateMoodPoints(this.additionalMoodPoints, false, this.gameInfo.gameData.currentMoodPoints,
            this.gameInfo.gameData.moodPointHistory);
    }

    resolveDisplayedCard(selectedInd) {
        // selectedInd is the number of the button that has been selected

        if (this.state.eventTracker === true){
            const response = this.gameInfo.currentCard.responses[selectedInd];
            this.updateEventArr("RegularCard", response);
        }
        this.gameProtectPlanTran = {};
        if (this.gameInfo.currentCard.cardType && 
            (this.state.validCardTypes.includes(this.gameInfo.currentCard.cardType) ||
             this.gameInfo.currentCard.cardType === "dialog")) {
            if (selectedInd !== -1) {
                let response = this.gameInfo.currentCard.responses[selectedInd];
                this.responseValue = response.value;
                switch (response.category) {
                    case "cash":
                        if ((response.on && +response.value !== 0) || (!isNaN(+response.value))) {
                            let response = this.gameInfo.currentCard.responses[selectedInd];
                            // if response value is 0, then it means the player decided not to buy the item
                            if (this.gameInfo.cardImageObj.purchaseItem === true &&
                                +response.value !== 0){
                                this.purchasedAnItemThisTurn = true;
                                this.gamePurchaseArr = updateGamePurchaseArr(this.gameInfo.cardImageObj.itemName, 
                                    this.gameInfo.currentCard.imageDir, response.value,
                                    this.gameInfo.gameData.currentGameDate, this.gameInfo.gamePurchases.purchaseTable,
                                );
                                response.itemDesc = "Purchased a " + this.gameInfo.cardImageObj.itemName;
                                this.updateGamePurchases();  
                                this.gameInfo.cardImageObj.purchaseItem = false;                             
                            }
                            const objectDesc = this.determineObjectDesc(response.itemDesc, response.title, response.btnText);
                            if (+response.value !== 0){
                                this.applyCashOrCredit(response.value, objectDesc, response.on, 
                                    response.creditCardCategory );
                            }
                        }
                        break;
                    case "asset":
                        this.updateAsset(response.on, response.type, response.value, response.duration,
                            response.btnText, response.itemDesc, this.gameInfo.currentCard.title, response.replaceAmtSw);
                        if (response.on === "Job Salary" &&
                            response.duration === "-1") {
                            this.checkIfMaxSalary();
                            let newTaxAmt = calcTaxAmt(this.gameInfo.gameData.assetTable);
                            let taxDesc = "Federal, FICA (Social Security)"
                            this.updateExpense("Payroll taxes", "flat", newTaxAmt, "-1", "", "", taxDesc, true);
                        }
                        break;
                    case "expense":
                        this.updateExpense(response.on, response.type, response.value, response.duration,
                            response.btnText, response.itemDesc, this.gameInfo.currentCard.title, response.replaceAmtSw);
                        break;
                    case "loan":
                        this.updateLoan(response.on, response.type, response.value, response.duration,
                            response.btnText, response.itemDesc, this.gameInfo.currentCard.Title, response.replaceAmtSw);
                        break;
                    default:
                        let errorDesc = "Event does not have a valid on-field value";
                        this.generalErrorLog(errorDesc);
                        break;
                }
                if (response.rltnshpScore) {
                    let friendName = this.gameInfo.currentCard.friendName;
                    for (let i = 0; i < this.gameInfo.gameData.friendList.length; i++) {
                        let friendEntry = this.gameInfo.gameData.friendList[i];
                        if (friendName === friendEntry.name) {
                            let newRltnshpScore = +this.gameInfo.gameData.friendList[i].rltnshpScore +
                                +response.rltnshpScore;
                            this.gameInfo.gameData.friendList[i].rltnshpScore = newRltnshpScore;
                            break;
                        }
                    }
                }
                if (response.moodPoints) {
                    // update mood points as a result of an event
                    const moodPointValues = calculateMoodPoints(response.moodPoints, false, 
                        this.gameInfo.gameData.currentMoodPoints,
                        this.gameInfo.gameData.moodPointHistory);
                    
                    if (moodPointValues.moodPoints > ConfigFile.gameStartItems.maxMoodPoints){
                        let errorDesc = "Mood Points are greater than the maximum - calculated mood points: " +
                            moodPointValues.moodPoints;
                        this.generalErrorLog(errorDesc);
                        this.gameInfo.gameData.currentMoodPoints = ConfigFile.gameStartItems.maxMoodPoints;
                    }else{
                        this.gameInfo.gameData.currentMoodPoints = moodPointValues.moodPoints;
                    }
                    this.gameInfo.gameData.moodPointHistory = moodPointValues.moodPointHistory;
                }
                this.props.calcMoodRetirementScores();
                // determine if process needs to update the conditionsTable
                let checkResponse = response;
                if ((!checkResponse.triggerCondition || checkResponse.triggerCondition === "") &&
                    (!checkResponse.deleteCondition || checkResponse.deleteCondition === "") &&
                    (!checkResponse.deleteClass || checkResponse.deleteClass === "") &&
                     this.purchasedAnItemThisTurn === false) {
                    // no condition table update is required
                } else {
                    let imageDir = "";
                    if (this.purchasedAnItemThisTurn === true){
                        imageDir = this.gameInfo.currentCard.imageDir;
                        this.purchasedAnItemThisTurn = false;
                    }
                    let prevCondName = "";
                    const prevConditionObj = 
                            this.gameInfo.gameData.conditionsTable.find(elem => elem.condName === checkResponse.triggerCondition);
                    if (prevConditionObj){
                        prevCondName = prevConditionObj.condName;
                    }
                    this.gameInfo.gameData.conditionsTable =
                        processEventChangesToConditionsTable(this.gameInfo.gameData.conditionsTable,
                            checkResponse.triggerCondition, checkResponse.duration, checkResponse.deleteCondition,
                            checkResponse.deleteClass, this.gameInfo.eventConditions, 
                            this.gameInfo.gamePurchases.purchaseTable, imageDir);
                    if (checkResponse.triggerCondition){
                        const newConditionObj = 
                            this.gameInfo.gameData.conditionsTable.find(elem => elem.condName === checkResponse.triggerCondition);
                        if (newConditionObj.protectPlanType && newConditionObj.protectPlanType !== "" &&
                            newConditionObj.condName !== prevCondName ){
                            const tranAmount = (+response.value * -1).toString();
                            this.gameProtectPlanTran = {gameID: this.gameInfo.gameData._id, 
                                protectPlanType: newConditionObj.protectPlanType, condName: checkResponse.triggerCondition,
                                tranType: "Add", gameDate: this.gameInfo.gameData.currentGameDate,
                                tranAmount: tranAmount};
                        }
                        if (this.gameInfo.gamePhase === "1" &&
                            newConditionObj && 
                            newConditionObj.skipEventCategory &&
                            newConditionObj.skipEventCategory !== ""){
                            //  ensure that any/all cards that are part of the skipEventCategory
                            //  are removed from the cardList.... EX:  if injured on the job
                            //  then don't display any more job events until time to heal.
                            let newCardList = [];
                            const skipCategoryArr = [newConditionObj.skipEventCategory];
                            newCardList = replaceInvalidCardEvents(this.gameInfo.cardList,
                                skipCategoryArr, "skipEventArr", this.gameInfo.gamePhase )
                            this.gameInfo.cardList = JSON.parse(JSON.stringify(newCardList));
                            this.props.setGameInfo(this.gameInfo.cardList, 'cardList');
                        }
                    }
                }
               
            }
            if (isNaN(+this.gameInfo.gameData.currentCash)) {
                let errorDesc = "Cash is NaN in resolveDisplayedCard process. Response selected: " + selectedInd;
                this.generalErrorLog(errorDesc);
            }
          
            if (isNaN(+this.responseValue)) {
                let errorDesc = "On value is not numeric...  Response selected: " + selectedInd;
                this.generalErrorLog(errorDesc);
            }
            if (!this.gameInfo.currentCard.responses[selectedInd].linkTo ||
                this.gameInfo.currentCard.responses[selectedInd].linkTo === "") {
                    this.setState({cardDisabled: false});
            } else {
                if (this.gameInfo.currentCard.responses[selectedInd].linkTo === "earn-badge"){
                    this.setState({earnBadge: true});
                }else{
                    this.props.onNavigate(this.gameInfo.currentCard.responses[selectedInd].linkTo);
                }
            }
        }
       
        this.updateAfterCardProcessed();
        if (this.gameInfo.currentCard.lastCard === true){
            this.gameInfo.currentCard = {};
            this.props.setGameInfo(this.gameInfo.currentCard, "currentCard");
            this.lastCardDisplayed();
        }else{
            if (this.gameInfo.cardImageObj.cardImage === true && 
                this.gameInfo.cardImageObj.cardImageType !== "funStuff") {
                    this.gameInfo.cardImageObj = {};
                    this.gameInfo.cardImageObj.cardImage = false;
            }
            const maxIndx = this.gameInfo.cardList.length - 1;
            this.eventCategory = this.gameInfo.cardList[maxIndx].eventCategory; 
            this.gameInfo.cardInProcess = false;
            this.props.setGameInfo(this.gameInfo.cardInProcess, "cardInProcess");
            if(this.state.timeout) clearTimeout(this.state.timeout);
                this.state.timeout = setTimeout(() => {
                this.setState({clickImageStartSw: true});
                }, 7000);
            this.flipNextCard = true;
            this.processNextCard();
        }
    }

    checkIfMaxSalary() {
        if (this.saveNewSalary > this.gameInfo.pictureInfo.jobMaxSalary) {
            let maxSalaryCondition = this.gameInfo.gameData.conditionsTable.find(elem => elem.condName === "max-salary");
            if (!maxSalaryCondition) {
                let conditionObj = { condName: "max-salary", class: "career" };
                this.gameInfo.gameData.conditionsTable.push(conditionObj);

            }
        }
    }
    
    updateAsset(assetName, updateType, updateValue, duration, btnText, itemDesc, eventTitle, replaceAmtSw) {
        const objectDesc = this.determineObjectDesc(itemDesc, eventTitle, btnText);
        this.tableToUpdate = this.gameInfo.gameData.assetTable;
        this.applyCardUpdate(updateType, updateValue, duration, objectDesc, replaceAmtSw, assetName, "Asset");
        this.gameInfo.gameData.assetTable = this.tableToUpdate;
        this.props.setGameInfo(this.gameInfo.gameData.assetTable, "gameData", "assetTable");
    }

    updateExpense(expenseName, updateType, updateValue, duration, btnText, itemDesc, eventTitle, replaceAmtSw) {
        const objectDesc = this.determineObjectDesc(itemDesc, eventTitle, btnText);
        this.tableToUpdate = this.gameInfo.gameData.expenseTable;
        this.applyCardUpdate(updateType, updateValue, duration, objectDesc, replaceAmtSw, expenseName,
            "Expense");
        this.gameInfo.gameData.expenseTable = this.tableToUpdate;
        this.props.setGameInfo(this.gameInfo.gameData.expenseTable, "gameData", "expenseTable");
    }

    updateLoan(loanName, updateType, updateValue, duration, btnText, itemDesc, eventTitle, replaceAmtSw) {
        let intRate = ConfigFile.gameBoardLoans.intRate;
        let loanTerm = ConfigFile.gameBoardLoans.loanTerm;
        let downPaymentPct = ConfigFile.gameBoardLoans.pctDownPayment;
        let downPaymentAmt = +(+downPaymentPct * +updateValue).toFixed(2);
        let loanPayment = monthlyLoanAmt(updateValue, intRate, loanTerm);
        const objectDesc = this.determineObjectDesc(itemDesc, eventTitle, btnText);
        this.tableToUpdate = this.gameInfo.gameData.loanTable;
        let loanMonths = +loanTerm * 12;
        this.applyCardUpdate(updateType, loanPayment, loanMonths, objectDesc, replaceAmtSw,
            loanName, "Loan", intRate, updateValue, loanTerm, downPaymentAmt, );
        this.gameInfo.gameData.loanTable = this.tableToUpdate;

        this.props.setGameInfo(this.gameInfo.gameData.loanTable, "gameData", "loanTable");
    }
    //  issues - dialog indx error (either saveIndx or the friend...?)
    //  achievements earned but no celebration
    //  achievement earned after 2 months and s/b 12 (ensure the month check has "+")
    getGameTableObject(category, itemType, objectDesc){
        let outTable = [];     
        let tableItemChanged = {};     
        switch (category){
            case "asset":
                outTable = this.gameInfo.gameData.assetTable;
                tableItemChanged = outTable.find(elem => elem.assetItem  === 
                    itemType);
                break;
            case "expense":
                outTable = this.gameInfo.gameData.expenseTable;
                if (itemType === "Misc Expenses" || itemType === "Charities"){
                    tableItemChanged = outTable.find(elem => elem.expItem + elem.expDesc === 
                        itemType + objectDesc);
                }else{
                    tableItemChanged = outTable.find(elem => elem.expItem === itemType );
                }
                break;
            case "loan":
                outTable = this.gameInfo.gameData.loanTable;
                tableItemChanged = outTable.find(elem => elem.loanType === itemType);
                break;
            default:
                break;
        }
       
        return tableItemChanged;

    }

    applyCashOrCredit(spendAmt, eventDesc, onValue, creditCategory) {
        const applyCash = applyCashOrCredit(spendAmt, eventDesc, onValue, creditCategory, 
            this.gameInfo.gameData.spendingHistory, this.gameInfo.gameData.currentCash,
            this.gameInfo.creditCardInfo);
        this.gameInfo.gameData.spendingHistory = applyCash.spendingHistory;
        if (applyCash.updateCashOrCredit === "cash"){
            this.gameInfo.gameData.currentCash = applyCash.currentCash;
            this.props.setGameInfo(this.gameInfo.gameData.currentCash, "gameData", "currentCash");
        }else{
            this.gameInfo.creditCardInfo = applyCash.creditCardInfo;
            this.updateCreditCard();
        }
        if (applyCash.error === true){ 
            this.generalErrorLog(applyCash.errorDesc);
        }
    }

    determineLastCardInHand() {
        this.specialCardCount = 1;
        var remainder;
        var divisor;
        if (this.monthsPerTurn <= 3){
            //  next activity will occur every 3 months
            divisor = 3;
        }else{
            //  alternate the lifestyle and activity end of turn cards
            divisor = 2;
        }
        remainder = (+this.turnCount - 1) % divisor;
        let lastCard = "";
        let lastCardObj = "";
        if (remainder === 1) {
            const currentMiscExp = findRemoveTableItem(this.gameInfo.gameData.expenseTable, 
                "misc", false, "shortName")
            const currentExpAmt = currentMiscExp.expAmount;
            const nbrMonthsPlayed = this.totalGameMonths - this.gameInfo.gameData.nbrGameMonths;
            lastCard = lifestyleCard(currentExpAmt, nbrMonthsPlayed);
        } else {
            if (remainder === 0) {
                lastCardObj = lastCardDataset.find(elem => elem.lastCardType === "ActivityCard");
                lastCard = lastCardObj.lastCardValues;
            } else {
                lastCardObj = lastCardDataset.find(elem => elem.lastCardType === "NextTurn");
                lastCard = lastCardObj.lastCardValues;
            }
        }
        this.gameInfo.cardList.push(lastCard);
        
    }

    createExtraCards() {
        if (this.jokeCard === true){
            let jokeCard = buildJokeCard(this.gameInfo.gamePhase);
            this.insertCardInHand(jokeCard);
            this.jokeCard = false;
        }
        if (this.friendMonth === true) {
            this.selectAFriend();
        }
        if (this.badgeMonth === true){
            this.createBadgeCard();
        }
       
    }

    selectAFriend() {
        let friendsTable = JSON.parse(JSON.stringify(this.gameInfo.gameData.friendList));
        this.beforeFriendList = JSON.parse(JSON.stringify(this.gameInfo.gameData.friendList));
        this.nbrFriendsMet = calcNbrFriendsMet(friendsTable);
        let friendIndx = null;
        if (this.nbrFriendsMet < friendsTable.length) {
            friendIndx = determineIfTimeToMeetNewFriend(friendsTable, this.nbrFriendsMet,
                this.gameInfo.gameData.currentGameDate);
        } else {
            friendIndx = calcRandomNumberWithMax(this.nbrFriendsMet, true);
        }
        let friendName = friendsTable[friendIndx].name;
        if (friendsTable[friendIndx].introDate === "") {
            friendsTable[friendIndx].dialogIndx = "firstTime";
        }
        let friendDialogIndx = friendsTable[friendIndx].dialogIndx;
        const beforeDialogIndx = friendDialogIndx;
        // dialogIndx is updated in retrieveGameDialog  
        let dialogItem = retrieveGameDialog(friendName, friendDialogIndx, 
                this.gameInfo.gameData.conditionsTable);
        let currentCard = buildCardFromDialog(friendName, dialogItem);
        const friendCardInfo = {friendName: friendName, dialogIndx: dialogItem.dialogIndx};
        this.gameInfo.friendCardInfo = friendCardInfo;
        console.log("friend card info initially set: ", this.gameInfo.friendCardInfo);
        this.props.setGameInfo(friendCardInfo, "friendCardInfo");
        if (this.gameInfo.cardList.length > 1) {
            this.insertCardInHand(currentCard);
        } 
        if (dialogItem.dialogIndx === beforeDialogIndx){
            //  trying to resolve an intermittent issue where the dialog index
            //  is not getting updated
            const errorDesc = "dialog index not updated - selectAFriend";
            const errorObj = {player: this.gameInfo.gameData.user, 
                friendName: friendName, 
                dialogIndx: dialogItem.dialogIndx,
                currentCard: currentCard,    
            }; 
            this.generalErrorLog(errorDesc, errorObj);          
        }
    }

    createBadgeCard() {
        if (this.nextBadge !== 0) {
            let badgeCard = buildBadgeCard(this.nextBadge);
            this.insertCardInHand(badgeCard);
        }
    }

    insertCardInHand(currentCard) {
        let indx = 1;
        if (this.gameInfo.gamePhase === "1"){
            // subtract 2 to ensure the card is at least 2 card prior to last card
            // that way if go out and come back in, it won't skip the last card
            let totalCards = this.gameInfo.cardList.length - 2;
            indx = calcRandomNumberWithMax(totalCards, true) + 1;
        }else{
            const eventNbrObj = EventCategoryList.find(elem => elem.category === currentCard.eventCategory);
            const eventNbr = eventNbrObj.number;
            for (let i=0; i<this.eventNbrArr.length; i++){
                if (eventNbr === this.eventNbrArr[i]){
                    indx = i;
                    break;
                }
            }
        }
        this.gameInfo.cardList.splice(indx, 0, currentCard);
        this.props.setGameInfo(this.gameInfo.cardList, "cardList");
    }

    processEndOfTurn(){     
        let accountType = sessionStorage.getItem("accountType");
        if (accountType === "teacher") {
            this.updateLeaderBoard();
        }
        this.props.setGameInfo(this.gameInfo.gameData.currentCash, "gameData", "currentCash");
        if (this.friendMonth === true){
            console.log("***saveFriendIndx before processNextTick is: ", this.saveFriendIndx,
                " friendList is: ", this.gameInfo.gameData.friendList)
        }
        this.processNextTick();
        this.setState({cardDisabled: false});
        if (this.friendMonth === true){
            console.log("***saveFriendIndx after processNextTick is: ", this.saveFriendIndx,
                " friendList is: ", this.gameInfo.gameData.friendList)
        }
        if (this.friendMonth === true && this.saveFriendIndx){
            if (this.gameInfo.gameData.friendList[this.saveFriendIndx].dialogIndx ===
                this.beforeFriendList[this.saveFriendIndx].dialogIndx){
                    //  trying to resolve an intermittent issue where the dialog index
                    //  is not getting updated
                    const errorDesc = "dialog index not updated - processEndOfTurn";
                    const friendCardInfo = this.props.gameInfo.friendCardInfo;
                    const errorObj = {player: this.gameInfo.gameData.user, 
                        friendName: this.gameInfo.gameData.friendList[this.saveFriendIndx].name, 
                        friendIndx: this.saveFriendIndx,
                        reduxValueofIndx: friendCardInfo,
                        dialogIndx: this.gameInfo.gameData.friendList[this.saveFriendIndx].dialogIndx,
                        cardTitle: this.gameInfo.currentCard.title, 
                        beforeFriend: this.beforeFriendList[this.saveFriendIndx],
                        changeFriend: this.changeFriendList[this.saveFriendIndx],
                        updatedFriend: this.gameInfo.gameData.friendList[this.saveFriendIndx]}; 
                    this.generalErrorLog(errorDesc, errorObj);          
            }
        }
    }

    processNextTick() {
        const nextTurnObj = processNextTurn(this.gameInfo.gameData, this.gameInfo.pictureInfo, 
            this.gameInfo.eventConditions, this.gameInfo.savingsInfo,
            this.gameInfo.creditCardInfo, this.props.timeWizardInfo,
            this.props.totalNbrGameMonths, this.props.summaryInvestment, this.props.investmentMaster,
            this.state.eventTracker,
            this.props.moneyMgmtTestArr,
            this.props.funStuffInfo ); 
        if (nextTurnObj.pictureInfoChanged === true){
            this.gameInfo.pictureInfo = nextTurnObj.pictureInfo;
            this.props.setGameInfo(this.gameInfo.pictureInfo, "pictureInfo");
        }
        if (nextTurnObj.notificationArr.length > 0){
            this.notificationArr = this.notificationArr.concat(nextTurnObj.notificationArr);
            this.props.setGameInfo(this.notificationArr, "notificatioArr");
        }
        if (nextTurnObj.endGameReason !== "") {
            this.props.onEnd(nextTurnObj.endGameReason);
        }
        if (nextTurnObj.updateCreditCard === true){
            this.updateCreditCard();
        }
        if (this.gameInfo.gameData.unlockedFeatures.length > 0){
            this.unlockedFeaturesRoadmapArr = nextTurnObj.unlockedFeaturesRoadmapArr;
        }
        if (isNaN(nextTurnObj.currentCash)){
            const errorDesc = "unlocked features update cash is NaN";
            const errorObj = {unlockedFeaturesObj: nextTurnObj.unlockedFeaturesObj}
            this.generalErrorLog(errorDesc, errorObj);
        }else{
            this.gameInfo.gameData.currentCash = nextTurnObj.currentCash;
        }
        if (this.skipNotificationCheck === false){
            // setting to NoUpdate because the updateGamesCollection updates iconTable
            this.createNotifications("NoUpdate");
        }
        if (nextTurnObj.newAchievementArr.length > 0){
            this.setState({newAchievements: true});
            this.achievementArr = nextTurnObj.newAchievementArr; 
            for (let i=0; i<nextTurnObj.newAchievementArr.length; i++){
                let achievementObj = nextTurnObj.newAchievementArr[i];
                const notificationObj = addCelebrationToNotificationArr(achievementObj.achievementID,
                   "achievement", achievementObj.achievementTitle ); 
                this.notificationArr.push(notificationObj);
            }
        }   

        if (this.state.eventTracker === true){
            this.addToEventTracker(nextTurnObj.eventTrackerArr);
        }
        this.props.setGameInfo(this.gameInfo.pictureInfo, "pictureInfo");   
        this.props.setGameInfo(this.gameInfo.gameData, "gameData");
        this.updateGamesCollection();
        if (this.notificationArr.length > 0) {
            this.openNotificationModal();
        }
    }

    addToEventTracker(eventArr){
        // futureChange - eventTracker is seldom true and even when it is, max entries for the 
        // 'eventTrackerArr' is 2 at this time.  In future consider changing the lambda function 
        // to handle a table and not just a single eventTracker obj
        for (let i=0; i<eventArr.length; i++){
            const processName = eventArr[i].processName;
            let eventDetail = eventArr[i];
            delete eventDetail["processName"];
            this.saveEventTracker(eventDetail, processName);
        }
    }

   
    determineObjectDesc(itemDesc, eventTitle, btnText) {
        let objectDesc = "";
        if (itemDesc && itemDesc !== "") {
            objectDesc = itemDesc;
        } else {
            if (btnText === "Next Card" || btnText === "") {
                objectDesc = eventTitle;
            } else {
                objectDesc = btnText;
            }
        }
        return objectDesc;
    }

    applyCardUpdate(updateType, updateValue, duration, objectDesc, replaceAmtSw, updateName, tableType,
        intRate, totalLoanAmt, loanTerm, downPayment, ) {
        let revisedTableObj = updateRecurringGameDataObjects(tableType, updateName,
            updateType, updateValue, duration, objectDesc, replaceAmtSw, this.tableToUpdate,
            this.gameInfo.gameData.currentCash, this.gameInfo.gameData.currentGameDate,
            this.gameInfo.creditCardInfo, intRate, loanTerm, totalLoanAmt, downPayment);
        this.tableToUpdate = revisedTableObj.objectTable;
        if (revisedTableObj.applyType === "cash" || revisedTableObj.applyType === "credit") {
            if (revisedTableObj.applyType === "cash") {
                this.newCashAmt = Number(revisedTableObj.newCashAmt).toFixed(2);
                if (isNaN(this.newCashAmt)) {
                    let errorDesc = "NewCashAmt is NaN after updateRecurring value is: " + updateValue +
                        " updateType is: " + updateType;
                    this.generalErrorLog(errorDesc);
                } else {
                    this.gameInfo.gameData.currentCash = this.newCashAmt.toString();
                    this.props.setGameInfo(this.gameInfo.gameData.currentCash, "gameData", "currentCash");
                }
            } else {
                this.gameInfo.creditCardInfo = revisedTableObj.creditCardInfo;
                this.updateCreditCard();
            }
        }
        this.saveNewSalary = revisedTableObj.newSalaryAmt;
        if (revisedTableObj.spendAmt !== 0) {
            let spendAmt = revisedTableObj.spendAmt;
            if (spendAmt < 0){
                spendAmt = -1 * revisedTableObj.spendAmt;
            }
            this.gameInfo.gameData.spendingHistory.currentMonthSpendAmt += spendAmt;
        }
    }

    calculateResponseValue(response) {
        let returnValue = calculateResponseAmount(this.gameInfo.currentCard, response, this.gameInfo.gameData);
        sessionStorage.setItem("gameBtnText", this.gameInfo.currentCard.responses[response].btnText);
        return returnValue;
    }
    
    determineIfBadgeMonth(){
        this.badgeMonth = false;
        let badgeAlreadyEarnedForThisMonth = false;
        if (this.gameInfo.gameData.badgesEarned && this.gameInfo.gameData.badgesEarned.length > 0){
            let badgeIndx = this.gameInfo.gameData.badgesEarned.length - 1;
            if (this.gameInfo.gameData.badgesEarned[badgeIndx].dateEarned === 
                this.gameInfo.gameData.currentGameDate){
                    // If the most recent badge was earned in the current game month, then badgeMonth s/b false.
                    // This might happen if a person goes from the gameBoard to another process in the middle of a
                    // turn and the current month is a badge month.
                   badgeAlreadyEarnedForThisMonth = true;
            }
        }

        if (badgeAlreadyEarnedForThisMonth === false){
            // divisor is how many months (turns) should pass before a badge card is displayed
            let divisor = 1;
            if (this.monthsPerTurn <= 2){
                    divisor = 9;  
            }else{
                if (this.monthsPerTurn <= 4){
                    divisor = 6;
                }else{
                    if (this.monthsPerTurn <= 8){
                        divisor = 3;
                    }
                }
            }
            let remainder = this.turnCount % divisor; 
            if (remainder === 0){
                this.specialCardCount += 1;
                this.badgeMonth = true;
            }
        }
    }

    //   SECTION:  fetch processes

    async getNextEvents() {
        this.createConditionsUrlParm("dealNewCard");
        const conditionParm = (this.conditionArr).join(',');
        const skipCategoryParm = this.skipCategoryArr.join(',');
        const currentGameDate = this.gameInfo.gameData.currentGameDate;
        let updateLog = false;
        if (ConfigFile.gameBoard.backEndLogArr.includes(this.gameInfo.gameData.user)){
            updateLog = true;
        }
        const funcName = "dealNewHand";
        const urlParm = "?conditionsTable=" + conditionParm + "&career=" + this.career + 
            "&currentGameDate=" + currentGameDate + "&nbrMonths=" + this.monthsPerTurn +
            "&specialCardCount=" + this.specialCardCount + "&gameID=" + this.gameInfo.gameData._id +
            "&skipCategory=" + skipCategoryParm + "&updateLog=" + updateLog;
        const uri = buildUrl(this.state.environment, funcName, urlParm);
        fetch (uri, 
            { method: 'GET', headers: this.state.headers })
            .then(response => { 
                if (response.ok){
                  response.json().then(data => {
                      const output = JSON.parse(data);
                      const statusCode = output.statusCode;
                      if (statusCode === 200){
                        if (output.body.logError && output.body.logError !== ""){
                            const errorObj={function: funcName, subProcess: this.state.subProcess, 
                                status: statusCode, message: output.body.logError, silentAlert: true};
                            this.props.processError(errorObj);
                        }
                        this.determineLastCardInHand();   
                        for (const card of output.body.cardArr) {
                            this.gameInfo.cardList.push(card);
                        }
                        // the following can go away when start new year!
                        this.setCardType();
                        this.getCardsReadyForGame();
                }else{
                        const errorObj={function: funcName, subProcess: this.state.subProcess, 
                            status: statusCode, message: output.body.message};
                        this.props.processError(errorObj);
                      }
                });
            };
        });      
          
    }

    setCardType(){
        for (let i=0; i<this.gameInfo.cardList.length; i++){
            if (!this.gameInfo.cardList[i].cardType){
                this.gameInfo.cardList[i] = {...this.gameInfo.cardList[i], cardType: "card"};
            }
        }
    }

    getNextSpinnerCardList() {
        this.createConditionsUrlParm("getNextSpinner");
        const conditionParm = (this.conditionArr).join(',');
        const skipCategoryParm = this.skipCategoryArr.join(',');
        const funcName = "getNextSpinnerCardList";
        let updateLog = false;
        if (ConfigFile.gameBoard.backEndLogArr.includes(this.gameInfo.gameData.user)){
            updateLog = true;
        }
        let eventCategoryArr = (this.eventCategoryArr).join(',');

        const urlParm = "?&career=" + this.career + "&currentGameDate=" + this.gameInfo.gameData.currentGameDate + 
            "&nbrMonths=" + this.monthsPerTurn +
            "&eventCategoryList=" + eventCategoryArr + "&conditionsTable=" + conditionParm +
            "&skipCategory=" + skipCategoryParm + "&gameID=" + this.gameInfo.gameData._id +
            "&updateLog=" + updateLog;
        this.inputParm={career: this.career, currentGameDate: this.gameInfo.gameData.currentGameDate,
            eventCategoryList: eventCategoryArr, conditionsTable: conditionParm};
        const uri = buildUrl(this.state.environment, funcName, urlParm);
        fetch (uri, 
               { method: 'GET', headers: this.state.headers })
               .then(response => {
                  if (response.ok){
                    response.json().then(data => {
                    const output = JSON.parse(data);
                    const statusCode = output.statusCode;
                    if (output.statusCode === 200){ 
                        if (output.body.logError && output.body.logError !== ""){
                            const errorObj={function: funcName, subProcess: this.state.subProcess, 
                                status: statusCode, message: output.body.logError, silentAlert: true};
                            this.props.processError(errorObj);
                        }
                        this.determineLastCardInHand();   
                        for (const card of output.body.cardArr) {
                            this.gameInfo.cardList.push(card);
                        }
                        this.getCardsReadyForGame();
                    }else{
                        const errorObj={function: funcName, subProcess: this.state.subProcess, 
                            status: statusCode, message: output.body.message, errorObject: this.inputParm};
                        this.props.processError(errorObj);
                    }
                });
            };
      });      
    }

    getCardsReadyForGame(){
        let currentMonthDate = dateStrToPlainText(this.gameInfo.gameData.currentGameDate);
        let currentMonthDateArr = currentMonthDate.split(" ");
        const currentMonth = currentMonthDateArr[0];
        let gameMonthsObj = {prevMonth: undefined, currentMonth: currentMonth};
        this.gameInfo.prevNextMonth = gameMonthsObj;
        this.props.setGameInfo(gameMonthsObj, "prevNextMonth");
        this.createExtraCards();
        if (this.gameInfo.gamePhase === "2"){
            const maxIndx = this.gameInfo.cardList.length - 1;
            this.eventCategory = this.gameInfo.cardList[maxIndx].eventCategory; 
        }
        this.props.setGameInfo(this.gameInfo.cardList, 'cardList'); 
        //  the following waits 7 seconds and then displays the click image (finger pointer)
        if(this.state.timeout) clearTimeout(this.state.timeout);
            this.state.timeout = setTimeout(() => {
            this.setState({clickImageStartSw: true});
            }, 7000);
    }

    createConditionsUrlParm(processName){
        let conditionsTable = this.gameInfo.gameData.conditionsTable;
        this.conditionArr = [];
        this.skipCategoryArr = [];
        for (let i=0; i<conditionsTable.length; i++){
            if (conditionsTable[i].skipEventCategory &&
                conditionsTable[i].skipEventCategory !== "" ){
                    this.skipCategoryArr.push(conditionsTable[i].skipEventCategory);
            }
            if (conditionsTable[i].conditionClass === "career"){
                this.career = conditionsTable[i].condName;
            }else{
                this.conditionArr.push(conditionsTable[i].condName);
            }
        }
        if (this.skipCategoryArr.length > 0 && processName === "getNextSpinner"){
            this.processSkipCategory(processName);
        }
    }

    processSkipCategory(){
        //  ensure the skipCategory is in the eventCategoryArr so the
        //  follow-up event will be selected when gameSpinner is active
        for (let i=0; i<this.skipCategoryArr.length; i++){
            const eventCategory = this.skipCategoryArr[i];
            if (!this.eventCategoryArr.includes(eventCategory)){
                this.eventCategoryArr.push(eventCategory);
            }
        }
    }

    //   SECTION:  update and save processes 

    updateIconTable() {
        this.props.setGameInfo(this.gameInfo.gameData, "gameData");
        const funcName = "updateIconTable";
        const urlParm = "";
        const uri = buildUrl(this.state.environment, funcName, urlParm);
        if (!this.gameInfo.gameData.iconTable) {
            this.gameInfo.gameData.iconTable = [];
        }
        this.bodyObj = {
            "iconTable": this.gameInfo.gameData.iconTable
            };
        fetch (uri, 
            {
                method: 'PUT', 
                headers: this.state.headers,
                body: JSON.stringify(this.bodyObj)
            })
            .then(response => {
                if (response.ok){
                  response.json().then(data => {
                  const output = JSON.parse(data);
                  const statusCode = output.statusCode;
                  if (output.statusCode === 200){ 
                     //  update of iconTable was successful
                  }else{
                      const errorObj={function: funcName, subProcess: this.state.subProcess, 
                          status: statusCode, message: output.body.message, errorObject: this.bodyObj};
                      this.props.processError(errorObj);
                  }
              });
            }
        });
    }
     
    updateAfterCardProcessed() {
        this.props.setGameInfo(this.gameInfo.gameData, "gameData");
        const funcName = "updateGameCardProcessed";
        const urlParm = "";
        const bodyObj = {currentCash: this.gameInfo.gameData.currentCash,
            friendList: this.gameInfo.gameData.friendList,
            conditionsTable: this.gameInfo.gameData.conditionsTable,
            spendingHistory: this.gameInfo.gameData.spendingHistory,
            currentMoodPoints: this.gameInfo.gameData.currentMoodPoints,
            moodPointHistory: this.gameInfo.gameData.moodPointHistory,
            assetTable: this.gameInfo.gameData.assetTable,
            expenseTable: this.gameInfo.gameData.expenseTable,
            loanTable: this.gameInfo.gameData.loanTable,
            gameProtectPlanTran: this.gameProtectPlanTran
        };
        const uri = buildUrl(this.state.environment, funcName, urlParm);
        fetch (uri, 
            {
                method: 'PUT', 
                headers: this.state.headers,
                body: JSON.stringify(bodyObj)
            })
            .then(response => {
                if (response.ok){
                  response.json().then(data => {
                  const output = JSON.parse(data);
                  const statusCode = output.statusCode;
                  if (output.statusCode === 200){ 
                   //  update was successful
                  }else{
                      const errorObj={function: funcName, subProcess: this.state.subProcess, 
                          status: statusCode, message: output.body.message, errorObject: this.bodyObj};
                      this.props.processError(errorObj);
                  }
              });
            }
        });
    }

    updateGamesCollection() {
        this.props.setGameInfo(this.gameInfo.gameData, "gameData");
        this.gameInfo.gameData.currentMoodPoints = (+this.gameInfo.gameData.currentMoodPoints).toString();
        const beforeObj = this.gameInfo.gameData;
        const funcName = "updateGameEndOfTurn";
        const urlParm = "";
        const uri = buildUrl(this.state.environment, funcName, urlParm);
        const bodyObj = {
            "assetTable": JSON.parse(JSON.stringify(this.gameInfo.gameData.assetTable)),
            "expenseTable": JSON.parse(JSON.stringify(this.gameInfo.gameData.expenseTable)),
            "loanTable": JSON.parse(JSON.stringify(this.gameInfo.gameData.loanTable)),
            "conditionsTable": JSON.parse(JSON.stringify(this.gameInfo.gameData.conditionsTable)),
            "iconTable": JSON.parse(JSON.stringify(this.gameInfo.gameData.iconTable)),
            "pendingJob": this.gameInfo.gameData.pendingJob,
            "gameNbrMonths": this.gameInfo.gameData.gameNbrMonths,
            "nbrMonthsNegative": this.gameInfo.gameData.nbrMonthsNegative,
            "nbrMonthsMoodNegative": this.gameInfo.gameData.nbrMonthsMoodNegative,
            "carInfo": this.gameInfo.gameData.carInfo,
            "jobInfo": this.gameInfo.gameData.jobInfo,
            "spendingHistory": this.gameInfo.gameData.spendingHistory,
            "currentCash": this.gameInfo.gameData.currentCash,
            "currentMoodPoints": this.gameInfo.gameData.currentMoodPoints,
            "moodPointHistory": this.gameInfo.gameData.moodPointHistory,
            "currentGameDate": this.gameInfo.gameData.currentGameDate,
            "unlockedFeatures": this.gameInfo.gameData.unlockedFeatures,
            "achievementArr": this.gameInfo.gameData.achievementArr,
            "dateUpdated": this.state.dateTime.date,
        };
        
        fetch (uri, 
            {
                method: 'PUT', headers: this.state.headers,
                body: JSON.stringify(bodyObj)
            })
            .then(response => {
                if (response.ok){
                  response.json().then(data => {
                  const output = JSON.parse(data);
                  const statusCode = output.statusCode;
                  if (output.statusCode === 200){ 
                      this.props.setGameInfo(output.body, "gameData");
                      const afterObj = output.body;
                      const dataObj = {dataType: "gameData", beforeObj: beforeObj, afterObj: afterObj,
                            processName: "GameBoard", paragraphName: "updateGamesCollection"};
                      this.props.checkDataAccuracy(dataObj);
                  }else{
                      const errorObj={function: funcName, subProcess: this.state.subProcess, 
                          status: statusCode, message: output.body.message, errorObject: bodyObj};
                      this.props.processError(errorObj);
                  }
              });
            }
        });
    }

    updateLeaderBoard() {
        let currentDateTime = getCurrentDateTime();
        let totalInvestments = 0;
        if (this.gameInfo.summaryInvestment.length > 0){
           const summaryInvestments = this.gameInfo.summaryInvestment;
           totalInvestments = summaryInvestments.find(elem => elem.investType === "all").currentValue;
        }
        let gameScores = calculateMoodRetirementScores(this.gameInfo.gameData.currentMoodPoints,
            this.cashAmt, this.gameInfo.savingsInfo.totalSavingsAmt, totalInvestments,
            this.gameInfo.gameData.assetTable, this.gameInfo.gameData.currentGameDate);
        let nbrGameMonths = this.nbrMonthsPlayed + 1;
        let account = sessionStorage.getItem("userAccountNbr");
        const funcName = "saveLeaderBoard";
        const urlParm = "";
        const uri = buildUrl(this.state.environment, funcName, urlParm);
        let bodyObj = {
            "user": this.gameInfo.gameData.user,
            "startGameDate": this.gameInfo.gameData.startGameDate,
            "moodScore": gameScores.moodScore,
            "retirementScore": gameScores.retirementScore,
            "combinedScore": gameScores.combinedScore,
            "account": account,
            "nbrGameMonths": nbrGameMonths,
            "dateUpdated": currentDateTime.date,
        };
        //  saveLeaderBoard is an upsert so will either update or create leaderboard for this user
        fetch(uri,
            {
                method: 'post',
                headers: this.state.headers,
                body: JSON.stringify(bodyObj)
            })
            .then(response => {
                if (response.ok){
                  response.json().then(data => {
                  const output = JSON.parse(data);
                  const statusCode = output.statusCode;
                  if (output.statusCode === 200){ 
                      // "update of leader board in game-board was successful"
                  }else{
                      const errorObj={function: funcName, subProcess: this.state.subProcess, 
                          status: statusCode, message: output.body.message, errorObject: bodyObj};
                      this.props.processError(errorObj);
                  }
              });
            }
        });
    }

    onResultDisplay() {
        //do not remove card from hand if the card that was displayed is dialog, joke, or badge
        if (this.state.validCardTypes.includes(this.gameInfo.currentCard.cardType)){
            const funcName = "removeCardFromHand";
            const urlParm = "";
            const uri = buildUrl(this.state.environment, funcName, urlParm);
            fetch(uri,
                { method: 'PUT', 
                headers: this.state.headers })
                .then(response => {
                    if (response.ok){
                      response.json().then(data => {
                      const output = JSON.parse(data);
                      const statusCode = output.statusCode;
                      if (output.statusCode === 200){ 
                          // remove card from hand was successful;
                      }else{
                          let gameVersion = "";  
                          if (this.gameInfo.gameData.__v){
                              gameVersion = this.gameInfo.gameData.__v;
                          }
                          const dataObj={user: this.gameInfo.gameData.user, gameID: this.gameInfo.gameData._id,
                            hand: this.gameInfo.gameData.hand, currentCard: this.gameInfo.currentCard,
                            version: gameVersion};
                          const errorObj={function: funcName, subProcess: this.state.subProcess, 
                              status: statusCode, message: output.body.message, errorObject: dataObj};
                          this.props.processError(errorObj);
                      }
                  });
                }
            });
        }
        this.setState({responseReceived: true});
    }

    updateSavings(archiveSavingTrans){
        this.props.setGameInfo(this.gameInfo.savingsInfo, "savingsInfo");
     //   let beforeObj = this.gameInfo.savingsInfo;
        const funcName = "updateSavingsAmts";
        const moneyBuilderFeature = 
            this.gameInfo.gameData.unlockedFeatures.find(elem => elem.featureName === "moneyBuilder");
        let savingsClass = "bank";
        if (+moneyBuilderFeature.level >= 2){
            savingsClass = "retirement";
        }
        let urlParm = "?savingsClass=" + savingsClass;
        if (archiveSavingTrans === true){
            const currentYear = this.gameInfo.gameData.currentGameDate.split("-")[0];
            // subtracting 1 from historyYears because currentYear has already been incremented
            const archiveYear = +currentYear - +ConfigFile.savings.historyYears - 1; 
            const maxDate = archiveYear.toString() + "-12";
        //    const maxDate = "2025-12";   ---used for testing!
            console.log("maxDate is: ", maxDate);
            if (maxDate >= this.gameInfo.gameData.startGameDate){
                const archiveValue = "Yes";
                urlParm += "&archive=" + archiveValue + "&maxDate=" + maxDate;
            }
        }
        const uri = buildUrl(this.state.environment, funcName, urlParm);

        fetch(uri,
            {
                method: 'PUT', 
                headers: this.state.headers,
                body: JSON.stringify(this.savingsBodyObj)
            })
            .then(response => {
            if (response.ok){
                response.json().then(data => {
                const output = JSON.parse(data);
                const statusCode = output.statusCode;
                if (output.statusCode === 200){ 
                    this.props.setGameInfo(output.body, 'savingsInfo');
       //            let afterObj = output.body;
       //             beforeObj = this.modifySavingsObj(beforeObj);
       //             afterObj = this.modifySavingsObj(afterObj);
       //             const dataObj = {dataType: "savingsInfo", beforeObj: beforeObj, afterObj: afterObj,
       //                     processName: "GameBoard", paragraphName: "updateSavings"};
       //             this.props.checkDataAccuracy(dataObj);
                }else{
                    const errorObj={function: funcName, subProcess: this.state.subProcess, 
                        status: statusCode, message: output.body.message, errorObject: this.savingsObj};
                    this.props.processError(errorObj);
                }
            });
          }
      });
    }

    modifySavingsObj(savingsObj){
        // removing entries that will always have disrepancies due to calculations done by lambda function
        let savingsCompareObj = JSON.parse(JSON.stringify(savingsObj));
        let savingsArr = savingsCompareObj.savingsArr;
        for (let i=0; i<savingsArr.length; i++){
             delete savingsArr[i].savingTotals;
        }
        delete savingsCompareObj.totalSavingsAmt;
        return savingsCompareObj;
    }

    updateCreditCard() {
        this.props.setGameInfo(this.gameInfo.creditCardInfo, "creditCardInfo");
        this.creditCardObj = JSON.parse(JSON.stringify(this.gameInfo.creditCardInfo));
        const beforeObj = this.gameInfo.creditCardInfo;
        const funcName = "updateCreditCardInfo";
        const urlParm = "?gameID=" + this.gameInfo.gameData._id;
        const uri = buildUrl(this.state.environment, funcName, urlParm);

        fetch(uri,
            {
                method: 'PUT', 
                headers: this.state.headers,
                body: JSON.stringify(this.creditCardObj)
            })
            .then(response => {
                if (response.ok){
                    response.json().then(data => {
                    const output = JSON.parse(data);
                    const statusCode = output.statusCode;
                    if (output.statusCode === 200){ 
                        this.props.setGameInfo(output.body, 'creditCardInfo');
                        const afterObj = output.body;
                        const dataObj = {dataType: "creditCardInfo", beforeObj: beforeObj, afterObj: afterObj,
                            processName: "GameBoard", paragraphName: "updateCreditCard"};
                        this.props.checkDataAccuracy(dataObj);
                    }else{
                        const errorObj={function: funcName, subProcess: this.state.subProcess, 
                            status: statusCode, message: output.body.message, errorObject: this.creditCardObj};
                        this.props.processError(errorObj);
                    }
                });
              }
          });
    }

    updateGamePurchases(){
        if (!this.gameInfo.gamePurchases.gameID){
            this.gameInfo.gamePurchases = {gameID: this.gameInfo.gameData._id,
                purchaseTable: this.gamePurchaseArr};
        }else{
            this.gameInfo.gamePurchases.purchaseTable = this.gamePurchaseArr;
        }
        const beforeObj = this.gameInfo.gamePurchases;
        this.gamePurchasesObj = JSON.parse(JSON.stringify(this.gameInfo.gamePurchases));
        const funcName = "updateGamePurchases";
        const urlParm = "?gameID=" + this.gameInfo.gameData._id;
        const uri = buildUrl(this.state.environment, funcName, urlParm);

        fetch(uri,
            {
                method: 'PUT', 
                headers: this.state.headers,
                body: JSON.stringify(this.gamePurchasesObj)
            })
            .then(response => {
                if (response.ok){
                    response.json().then(data => {
                    const output = JSON.parse(data);
                    const statusCode = output.statusCode;
                    if (output.statusCode === 200){ 
                        this.props.setGameInfo(output.body, 'gamePurchases');
                        const afterObj = output.body;
                        const dataObj = {dataType: "gamePurchases", beforeObj: beforeObj, afterObj: afterObj,
                            processName: "GameBoard", paragraphName: "updateGamePurchases"};
                        this.props.checkDataAccuracy(dataObj);
                    }else{
                        const errorObj={function: funcName, subProcess: this.state.subProcess, 
                            status: statusCode, message: output.body.message, errorObject: this.gamePurchasesObj};
                        this.props.processError(errorObj);
                    }
                });
              }
          });
    }

    updateGameTransactions(gameInvestmentObj){
        const funcName = "updateGameInvestments";
        const urlParm = "?gameID=" + this.gameInfo.gameData._id + "&investType=bond";
        const uri = buildUrl(this.state.environment, funcName, urlParm);
    
        fetch(uri,
            {
                method: 'PUT', 
                headers: this.state.headers,
                body: JSON.stringify(gameInvestmentObj)
            })
            .then(response => {
            if (response.ok){
                response.json().then(data => {
                const output = JSON.parse(data);
                const statusCode = output.statusCode;
                if (output.statusCode === 200){ 
                    //  update of gameTransactions was successful
                }else{
                    const errorObj={function: funcName, subProcess: this.state.subProcess, 
                        status: statusCode, message: output.body.message, errorObject: this.gameInvestmentObj};
                    this.props.processError(errorObj);
                }
            });
            }
        });
    }

    saveEventTracker(eventObj, eventType) {
        let gameData = {};
        if (eventType === "LastCard"){
            gameData = this.beforeGameData;
        }else{
            gameData = JSON.parse(JSON.stringify(this.gameInfo.gameData));
            if (eventType === "TaxChange"){
                gameData.expenseTable = this.taxChgExpenseTable;
            }
        }
        const dataObject = createEventTrackerUpdateObject(eventType, "gameBoard",
           gameData, eventObj, this.gameInfo.creditCardInfo);
        const funcName = "saveEventTracker";
        const urlParm = ""
        const uri = buildUrl(this.state.environment, funcName, urlParm);

        fetch(uri,
            {
                method: 'post',
                headers: this.state.headers,
                body: JSON.stringify(dataObject)
            })
            .then(response => {
                if (response.ok){
                    response.json().then(data => {
                    const output = JSON.parse(data);
                    const statusCode = output.statusCode;
                    if (output.statusCode === 200){ 
                       //  save of event tracker was successful
                    }else{
                        const errorObj={function: funcName, subProcess: this.state.subProcess, 
                            status: statusCode, message: output.body.message, errorObject: dataObject};
                        this.props.processError(errorObj);
                    }
                });
              }
          });
    }

    generalErrorLog(errorDesc, dataObject) {
        if (!dataObject){
            dataObject = {currentCard: this.gameInfo.currentCard,
                currentCash: this.gameInfo.gameData.currentCash,
                assetTable: this.gameInfo.gameData.assetTable,
                expenseTable: this.gameInfo.gameData.expenseTable,
                loanTable: this.gameInfo.gameData.loanTable,
                conditionsTable: this.gameInfo.gameData.conditionsTable};
        }
        const message = errorDesc;
        const errorObj={function: "GeneralError", subProcess: this.state.subProcess, 
            status: 999, message: message, errorObject: dataObject, silentAlert: true};
        this.props.processError(errorObj);
    }

}


export default connect(mapStateToProps, mapDispatchToProps)(GameBoard);